<script>
/* global axios */
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
// Task D: seletor de bancos do nó "Consultar oferta" fica DINÂMICO por caixa
// — mesmo proxy que a Central de Simulação/Digitação já usa para falar com o
// simulador-api (ver BancosPainel.vue / simulador_api_controller.rb).
import simuladorApi from 'dashboard/api/simuladorApi';

/* Construtor visual do roteiro de atendimento (por caixa).
   Canvas feito em Vue 3 + SVG puro DE PROPÓSITO: a imagem do Chatwoot builda com
   `pnpm install --frozen-lockfile`, então qualquer dependência nova (vue-flow e
   afins) quebraria o build inteiro. Aqui não há dependência alguma. */

// Os formatos e limites acompanham a API oficial do WhatsApp (botões até 3,
// lista até 10, carrossel de 2 a 10 cards) — assim o roteiro fica compatível
// caso um dia seja levado para lá.
const TYPES = [
  { type: 'message',   label: 'Mensagem',      icon: '💬', hint: 'Só fala e segue' },
  { type: 'buttons',   label: 'Botões',        icon: '🔘', hint: 'Até 3 opções' },
  { type: 'list',      label: 'Lista',         icon: '📋', hint: 'De 4 a 10 opções' },
  { type: 'carousel',  label: 'Carrossel',     icon: '🎠', hint: 'Cards com imagem e botões' },
  { type: 'input',     label: 'Pedir dado',    icon: '🆔', hint: 'CPF, telefone...' },
  { type: 'link',      label: 'Botão de link', icon: '🔗', hint: 'Abre uma URL' },
  { type: 'image',     label: 'Imagem',        icon: '🖼️', hint: 'Envia uma foto' },
  { type: 'delay',     label: 'Digitando',     icon: '⏳', hint: 'Pausa com "digitando…"' },
  { type: 'condition', label: 'Condição',      icon: '🔀', hint: 'Se/senão' },
  { type: 'ai',        label: 'Passar para IA',icon: '🤖', hint: 'IA assume' },
  { type: 'bot',       label: 'Transferir para IA', icon: '🤖', hint: 'Entrega a conversa para outra IA (ex.: FGTS IA)' },
  { type: 'agent',     label: 'Passar p/ humano', icon: '🙋', hint: 'Atendente assume' },
  { type: 'http',      label: 'HTTP',          icon: '🌐', hint: 'Chama uma API (estilo n8n)' },
  { type: 'supabase',  label: 'Supabase',      icon: '🗄️', hint: 'Insere/consulta no banco' },
  { type: 'script',    label: 'Script',        icon: '🐍', hint: 'Roda Python isolado' },
  { type: 'splash',    label: 'Destaque',      icon: '✨', hint: 'Estoura na tela com imagem/vídeo (só webchat)' },
  { type: 'oferta',    label: 'Consultar oferta', icon: '💰', hint: 'Consulta os bancos de verdade e guarda o que achou' },
  { type: 'ofertas',   label: 'Mostrar ofertas',  icon: '🏷️', hint: 'Mostra os cards das ofertas e espera o cliente escolher' },
  { type: 'digitar',   label: 'Digitar proposta', icon: '📝', hint: 'Envia ao banco a oferta escolhida para digitação de verdade' },
  { type: 'trocar_fluxo', label: 'Transferir BOT', icon: '🔀', hint: 'Passa a conversa para outro MODELO salvo, continuando de onde você escolher' },
  { type: 'end',       label: 'Encerrar',      icon: '🏁', hint: 'Fim do roteiro' },
];
const MAX_OPTIONS = { buttons: 3, list: 10 };
const MAX_CARDS = 10;
// Bancos do bloco "Consultar oferta" — FALLBACK fixo, só usado quando o fetch
// dinâmico (carregarBancos(), abaixo) falha (simulador-api fora do ar ou rota
// ainda não liberada no proxy). Em uso normal, `bancosDisponiveis` vem de
// GET .../simulador_api/bancos-habilitados?inbox_id=X&formato=adapters — só
// os bancos ATIVOS (com credencial) NESTA caixa (Task D, multi-tenant). É a
// MESMA lista de adapters que o servidor valida ao salvar (FLOW_BANCOS no
// mazam_web_controller.rb): banco fora dela é descartado, então as duas
// precisam andar juntas.
const BANCOS = [
  { id: 'soma_cel', nome: 'SOMA — Celetista' },
  { id: 'soma_uy3', nome: 'SOMA — UY3' },
  { id: 'v8', nome: 'V8' },
  { id: 'c6', nome: 'C6' },
  { id: 'facta', nome: 'Facta' },
  { id: 'uy3', nome: 'UY3' },
  { id: 'presenca', nome: 'Presença' },
];
const OFERTA_TETO_PADRAO = 25;
// Bloco "Digitar proposta": mapa `form_fields` inicial (campo do banco no
// simulador-api -> variável do fluxo). São os campos SEM equivalente
// "nome=nome" óbvio no engine (mazam-webchat/src/app.py::_FORM_CAMPOS_PADRAO
// já cobre nome/email/celular/nascimento/nome_mae/etc. lendo a variável de
// MESMO nome direto — só entram aqui os grupos aninhados endereco.*/
// recebimento.*, que exigem mapa explícito). É só ponto de partida: o usuário
// ajusta o nome da variável (lado direito) para bater com os blocos "Pedir
// dado" que ele já tem no roteiro, ou apaga a linha se não for usar.
const DIGITAR_FORM_FIELDS_PADRAO = {
  nascimento: 'nascimento',
  nome_mae: 'nome_mae',
  'endereco.cep': 'endereco_cep',
  'endereco.logradouro': 'endereco_logradouro',
  'endereco.numero': 'endereco_numero',
  'endereco.bairro': 'endereco_bairro',
  'endereco.cidade': 'endereco_cidade',
  'endereco.uf': 'endereco_uf',
  'recebimento.pix_tipo': 'recebimento_pix_tipo',
  'recebimento.pix_chave': 'recebimento_pix_chave',
};
// Bloco "Transferir para IA": sugestão para o caso que criou o bloco (o menu
// CLT × FGTS, em que o ramo FGTS cai na FGTS IA, que é o agent bot 1). É só
// SUGESTÃO de tela — quem manda no padrão de verdade é o servidor
// (WEBCHAT_BOT_FGTS_ID / WEBCHAT_URL_IA_FGTS), usado quando o campo fica vazio.
const BOT_PADRAO = {
  bot_id: 1,
  url: 'https://atendimento-ia.mazam.ai/fgts-ia/webhook/chatwoot',
  gatilho: 'Quero antecipar meu FGTS',
};

// ---- arquivo de roteiro (exportar/importar, estilo n8n) --------------------
// Assinatura + versão do arquivo. A chave `mazam_flow` guarda a VERSÃO do
// formato: quem importar um arquivo de versão maior do que esta sabe que é de
// um Chatwoot mais novo e recusa em vez de carregar meio errado.
const ARQUIVO_CHAVE = 'mazam_flow';
const ARQUIVO_VERSAO = 1;
// Teto de leitura — mesmo do MAX_JSON_BYTES dos modelos no servidor
// (mazam_flow_templates.rb). Arquivo maior que isso trava a aba à toa.
const ARQUIVO_MAX_BYTES = 512 * 1024;
// I3 (revisão 2026-08-13): mesmo teto que o servidor grava de qualquer jeito
// (FLOW_MAX_NODES, mazam_web_controller.rb:748) — sem isto um arquivo com
// milhares de blocos mínimos passa fácil no teto de BYTES acima (cada bloco
// `{"id":"a1","type":"end"}` custa ~24 bytes) e trava a aba inteira antes de
// chegar perto do "Salvar roteiro".
const ARQUIVO_MAX_BLOCOS = 60;

/* Campos que cada tipo de bloco realmente tem.
   ⚠️ ESPELHO MANUAL de `build_flow_node` (mazam_web_controller.rb) — anda junto
   com o Ruby, igual à dívida já registrada de BANCOS/FLOW_BANCOS/ADAPTERS (ver
   CLAUDE.md do repo). Se um tipo ganhar campo novo lá, adicione aqui também,
   senão o campo some do arquivo exportado.
   Por que podar: `normalizeNode()` injeta TODOS os defaults em TODOS os nós, e
   sem esse filtro um bloco "Mensagem" sairia no arquivo com headers/env/
   form_fields/bancos vazios — arquivo inflado e diff ilegível. Podando, o
   arquivo fica igualzinho ao que o servidor grava. */
const CAMPOS_COMUNS = ['id', 'type', 'x', 'y', 'text', 'next'];
const CAMPOS_POR_TIPO = {
  message: [],
  end: [],
  agent: ['label'],
  buttons: ['options', 'field', 'allow_text'],
  list: ['options', 'button', 'field', 'allow_text'],
  carousel: ['cards', 'field', 'allow_text'],
  link: ['url', 'label'],
  image: ['src'],
  delay: ['seconds'],
  input: ['validate', 'field', 'error'],
  condition: ['var', 'op', 'value', 'else'],
  ai: ['agent'],
  http: ['metodo', 'url', 'headers', 'query', 'body_modo', 'body', 'timeout_seg', 'mapear', 'salvar_em'],
  supabase: ['op', 'tabela', 'valores', 'filtros', 'limit', 'salvar_em'],
  script: ['code', 'env', 'salvar_em'],
  splash: ['titulo', 'midia', 'botoes'],
  oferta: ['bancos', 'teto_s', 'salvar_em', 'else'],
  bot: ['bot_id', 'url', 'gatilho'],
  ofertas: ['auto_digitar', 'form_fields'],
  digitar: ['banco', 'indice', 'form_fields'],
  trocar_fluxo: ['flow_id', 'inicio'],
};
// Sub-listas (mesmos sanitizadores do servidor: sanitize_flow_options,
// sanitize_flow_cards, sanitize_kv, sanitize_mapear, sanitize_splash_botoes).
const CAMPOS_SUB = {
  options: ['label', 'value', 'description', 'url', 'next'],
  cards: ['image', 'title', 'body', 'buttons'],
  buttons: ['label', 'value', 'url', 'next'],
  headers: ['chave', 'valor'],
  query: ['chave', 'valor'],
  mapear: ['campo', 'var'],
  botoes: ['label', 'url'],
};

/* Heurísticas de segredo. O certo é o operador usar {{secret:NOME}} (o valor de
   verdade fica na caixa, nunca no roteiro) — mas quem colou um Bearer à mão no
   header não pode ver esse token viajar num arquivo que vai por e-mail/WhatsApp
   para outra empresa. Valor que é SÓ interpolação ({{...}}) não é segredo e
   passa inteiro. */
// m5 (revisão 2026-08-13): "auth"/"signature" entraram na lista — sem eles um
// header "X-Auth" ou "X-Signature" com valor cru passava batido (o grupo
// `x-[\w-]*-(key|token)` só pegava sufixo -key/-token, não -auth sozinho).
const RE_SEGREDO_CHAVE = /(authorization|auth|api[-_]?key|apikey|token|secret|senha|password|cookie|signature|x-[\w-]*-(key|token))/i;
const RE_SEGREDO_VALOR = /(bearer\s|basic\s|sk-[a-z0-9]|eyJ[\w-]+\.)/i;
const RE_SO_VARIAVEL = /^\s*\{\{[^{}]+\}\}\s*$/;
// URL que não deveria atravessar de instalação: query com credencial ou host
// interno do nosso cluster (não existe no servidor de destino).
const RE_URL_SEGREDO = /[?&](token|key|apikey|api_key|secret|senha|password)=/i;
const RE_URL_INTERNA = /(\.svc\.cluster\.local|atendimento-ia\.mazam\.ai|(^|\/\/)(localhost|127\.0\.0\.1|10\.|192\.168\.))/i;

const NODE_W = 210;
const NODE_H = 92;

export default {
  props: {
    inbox: { type: Object, required: true },
    // 'webchat' (default, comportamento atual) ou 'whatsapp'. No WhatsApp valem
    // as regras da Meta e alguns campos não existem (ex.: travar o compositor
    // do cliente é impossível — ele sempre pode digitar).
    channel: { type: String, default: 'webchat' },
    // Embutido dentro da tela de IA do WhatsApp: quem salva é o pai.
    embedded: { type: Boolean, default: false },
    // IAs criadas na caixa: alimentam o seletor do bloco "Passar para IA".
    agentesIa: { type: Array, default: () => [] },
    // Controle de Acesso (key 'Inbox Fluxo Webchat Editar'): sem ela o canvas
    // abre para CONSULTA — dá pra navegar, dar zoom e simular, mas nada muta
    // o roteiro. Default false = comportamento atual (aba do WhatsApp intacta).
    somenteLeitura: { type: Boolean, default: false },
  },
  // E1: quando embedded, quem salva de verdade é o pai (FlowWhatsappPage.vue,
  // POST /mazam_web/ia) — o botão de salvar do canvas só avisa que o clique
  // aconteceu, inclusive em tela cheia, onde o botão do pai fica inacessível.
  emits: ['save'],
  data() {
    return {
      enabled: false,
      start: '',
      nodes: [],
      selectedId: null,
      saving: false,
      loading: true,
      pan: { x: 40, y: 30 },
      zoom: 1,
      drag: null,        // { id, dx, dy } arrastando um nó
      panning: null,     // { x, y } arrastando o fundo
      linking: null,     // { from, port, x, y } ligando saída -> nó
      types: TYPES,
      bancosDisponiveis: BANCOS,
      sim: null,         // simulação do "Testar"
      full: false,       // canvas em tela cheia
      sbTabelas: [],     // tabelas Supabase liberadas nesta caixa
      sbColunas: [],     // colunas da tabela selecionada
      sbCarregando: false,
      acaoTestando: false,
      acaoResultado: '', // retorno do "Testar" de um nó de ação
      templates: [],     // modelos de roteiro salvos (servem a qualquer caixa)
      tplSel: '',
      // Arquivo (exportar/importar JSON). O import só carrega no CANVAS — a
      // escrita de verdade continua sendo o "Salvar roteiro", que passa pelo
      // gate do servidor (require_mazam_admin + a key do Controle de Acesso)
      // e pelo sanitize_flow. Por isso importar aqui é seguro por construção.
      importAberto: false,
      importTexto: '',
      importErro: '',
      // Avisos do último exportar/importar: o que foi removido por segurança e
      // o que precisa de conferência na caixa de destino.
      avisos: [],
      avisosTitulo: '',
      // C1: avisos de EXECUÇÃO (código do nó "script", host do nó "http", URL
      // do nó "bot") — vêm sempre ANTES da lista acima e com destaque próprio
      // (vermelho, não âmbar), porque não é "revisar depois", é "isto roda
      // código/chama rede quando o roteiro tocar este bloco".
      avisoCritico: [],
      // C1: import com nó "script" contendo código aguardando confirmação
      // explícita (código à vista) antes de aplicar no canvas. Guarda o que
      // falta terminar de aplicar: { flow, origem, validos, avisos, blocos }.
      importScriptPendente: null,
      copiado: false,
      // E3: altura REAL de cada card (id -> px), medida via ResizeObserver.
      // NODE_H é só o valor inicial/mínimo — quando o card cresce (chips de
      // opção quebrando linha), a porta de saída e as curvas acompanham.
      nodeHeights: {},
      // IA desta caixa: modelo e chave próprios. A chave NUNCA volta do
      // servidor — só a dica do fim, para reconhecer qual está gravada.
      iaModelo: 'gpt-5-mini',
      iaChave: '',
      iaTemChave: false,
      iaDica: '',
      iaSalvando: false,
      modelos: ['gpt-5-mini', 'gpt-5', 'gpt-4.1', 'gpt-4.1-mini', 'gpt-4o', 'gpt-4o-mini'],
    };
  },
  computed: {
    ...mapGetters({ currentUser: 'getCurrentUser' }),
    // Mudança de escopo (decisão do dono, 2026-08-13): Exportar/Importar o
    // roteiro em arquivo .json vira canal de SAÍDA e ENTRADA que atravessa
    // contas inteiras — inclusive código Python executável no nó "script"
    // (ver C1 do review de export/import). Fica reservado ao super admin
    // (id 1), como o resto do ecossistema (Sidebar.vue, ChannelList.vue,
    // Index.vue) já faz para telas equivalentes.
    ehSuperAdmin() { return this.currentUser?.id === 1; },
    // Modelo de roteiro marcado como PADRÃO (o que nasce montado, e desligado,
    // em toda caixa nova). null quando ninguém marcou nenhum.
    modeloPadrao() { return this.templates.find(t => t.padrao) || null; },
    // Atalho local (nome curto usado no template) do modo consulta.
    soLeitura() { return this.somenteLeitura; },
    accountId() { return this.$route.params.accountId; },
    selected() { return this.nodes.find(n => n.id === this.selectedId) || null; },
    nodeById() {
      const m = {};
      this.nodes.forEach(n => { m[n.id] = n; });
      return m;
    },
    /* Uma aresta por saída: nós simples têm "next"; botões têm uma por opção;
       condição tem sim/não. */
    edges() {
      const out = [];
      this.nodes.forEach(n => {
        const ports = this.portsOf(n);
        ports.forEach((p, i) => {
          const target = this.nodeById[p.next];
          if (!target) return;
          out.push({
            key: `${n.id}:${i}`,
            from: n.id,
            port: i,
            d: this.pathBetween(n, i, ports.length, target),
            mid: this.midBetween(n, i, ports.length, target),
            label: p.label || '',
          });
        });
      });
      return out;
    },
    problems() {
      const out = [];
      if (!this.nodes.length) return out;
      if (!this.nodeById[this.start]) out.push('Nenhum bloco inicial definido.');
      const reachable = new Set();
      const walk = id => {
        if (!id || reachable.has(id) || !this.nodeById[id]) return;
        reachable.add(id);
        this.portsOf(this.nodeById[id]).forEach(p => walk(p.next));
      };
      walk(this.start);
      this.nodes.forEach(n => {
        if (!reachable.has(n.id)) out.push(`"${this.titleOf(n)}" não é alcançável a partir do início.`);
        const ports = this.portsOf(n);
        const dead = ports.filter(p => !p.next).length;
        if (dead && !['ai', 'agent', 'end'].includes(n.type)) {
          out.push(`"${this.titleOf(n)}" tem ${dead} saída(s) sem destino.`);
        }
        if ((n.type === 'buttons' || n.type === 'list') && !(n.options || []).length) {
          out.push(`"${this.titleOf(n)}" não tem nenhuma opção.`);
        }
        if (n.type === 'carousel') {
          if ((n.cards || []).length < 2) {
            out.push(`"${this.titleOf(n)}" precisa de pelo menos 2 cards.`);
          }
          const qtd = new Set((n.cards || []).map(c => (c.buttons || []).length));
          if (qtd.size > 1) {
            out.push(`"${this.titleOf(n)}": todos os cards precisam ter a mesma quantidade de botões.`);
          }
        }
        if (n.type === 'link' && !n.url) out.push(`"${this.titleOf(n)}" está sem URL.`);
        if (n.type === 'image' && !n.src) out.push(`"${this.titleOf(n)}" está sem a URL da imagem.`);
        if (n.type === 'oferta' && !(n.salvar_em || '').trim()) {
          out.push(`"${this.titleOf(n)}" está sem o nome da variável onde guardar as ofertas.`);
        }
        // Correção 2 (auditoria de conformidade 2026-08-12): auto-digitar
        // (nó "ofertas" com o toggle ligado — default LIGADO num nó novo —
        // ou um nó "digitar" avulso) manda a proposta pro banco usando
        // `form_fields` (campo do banco -> variável do fluxo). Se a
        // variável não é preenchida por NENHUM bloco "Pedir dado" no
        // roteiro, o cliente real só descobre quando a digitação falha
        // silenciosamente. Aviso cedo, na tela, antes de publicar.
        if ((n.type === 'ofertas' && n.auto_digitar) || n.type === 'digitar') {
          const faltando = this.camposFormFieldsSemColeta(n);
          if (faltando.length) {
            out.push(`"${this.titleOf(n)}": auto-digitar ligado mas falta coletar: ${faltando.join(', ')}.`);
          }
        }
      });
      return out;
    },
  },
  mounted() {
    this.load();
    if (!this.embedded) this.loadIa();
    this.carregarTabelas();
    this.carregarTemplates();
    this.carregarBancos();
    window.addEventListener('keydown', this.onKey);
  },
  watch: {
    // Ao abrir um nó Supabase, puxa as colunas da tabela dele; o resultado do
    // teste anterior some para não confundir com outro nó.
    selectedId() {
      this.acaoResultado = '';
      const n = this.selected;
      // Nó de oferta vindo de um modelo antigo pode chegar sem os campos novos;
      // sem isto o v-model dos checkboxes não teria array para marcar.
      if (n && n.type === 'oferta') {
        if (!Array.isArray(n.bancos)) n.bancos = [];
        if (!n.teto_s) n.teto_s = OFERTA_TETO_PADRAO;
        if (!n.salvar_em) n.salvar_em = 'ofertas';
      }
      // Roteiro salvo ANTES do auto-digitar (D) chega sem form_fields — sem
      // isto o textarea do painel abriria vazio mesmo o servidor já tendo o
      // padrão pronto (DIGITAR_FORM_FIELDS_PADRAO), confundindo quem liga o
      // toggle pela primeira vez num nó antigo.
      if (n && n.type === 'ofertas' && n.auto_digitar) this.garantirFormFieldsOfertas(n);
      if (n && n.type === 'supabase' && n.tabela) this.carregarColunas(n.tabela);
      else this.sbColunas = [];
    },
    // Review F3: sem isto, ligar o toggle "Digitar automaticamente" NUM NÓ JÁ
    // ABERTO (sem trocar de nó, então o watch de selectedId acima não dispara
    // de novo) deixava `form_fields` vazio — o pré-preenchimento só rodava na
    // TROCA de nó. Cobre exatamente o caso "abri um nó ofertas antigo e marquei
    // o checkbox na hora".
    'selected.auto_digitar'(ligou) {
      const n = this.selected;
      if (ligou && n && n.type === 'ofertas') this.garantirFormFieldsOfertas(n);
    },
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKey);
    document.body.style.overflow = '';
    if (this._flowResizeObserver) this._flowResizeObserver.disconnect();
  },
  methods: {
    /* Rede de segurança do modo consulta: mesmo com a UI escondida, atalho de
       teclado, arraste ou chamada via DevTools não podem mutar o roteiro de
       quem só tem leitura. Retorna true (e avisa) quando a ação é proibida. */
    bloqueadoParaEditar() {
      if (!this.soLeitura) return false;
      useAlert('Somente leitura: peça a liberação em Controle de Acesso.');
      return true;
    },
    /* Mesma rede de segurança, eixo diferente: Exportar/Importar arquivo é
       restrito ao super admin (id 1) — ver `ehSuperAdmin`. Chamada nos MESMOS
       3 pontos que `bloqueadoParaEditar()` já cobre (abrir modal, escolher
       arquivo, aplicar), para uma chamada direta pelo DevTools não passar por
       fora dos botões escondidos. */
    bloqueadoParaExportarImportar() {
      if (this.ehSuperAdmin) return false;
      useAlert('Exportar/Importar roteiro em arquivo é restrito ao super admin.');
      return true;
    },
    /* Mesma rede de segurança para o MODELO PADRÃO: ele decide o roteiro com
       que toda caixa NOVA da instalação nasce, então é do super admin (id 1).
       O servidor trava de verdade (gerenciar_modelos_de_roteiro!); isto aqui é
       para uma chamada pelo DevTools não passar por fora do botão escondido. */
    bloqueadoParaDefinirPadrao() {
      if (this.ehSuperAdmin) return false;
      useAlert('Definir o modelo padrão de roteiro é restrito ao super admin.');
      return true;
    },
    /* Tela cheia: o canvas ocupa a janela inteira para montar fluxo grande sem
       ficar espremido na coluna do painel. Esc também fecha. */
    toggleFull() {
      this.full = !this.full;
      document.body.style.overflow = this.full ? 'hidden' : '';
    },
    onKey(e) {
      if (e.key !== 'Escape') return;
      // O telefone fecha primeiro: ele está por cima da tela cheia.
      if (this.sim) { this.sim = null; return; }
      // Depois o modal de importar — Esc não pode ampliar/reduzir o canvas por
      // baixo de um modal aberto.
      if (this.importAberto) { this.importAberto = false; return; }
      if (this.full) this.toggleFull();
    },
    /* Rola a conversa e põe o cursor no campo — sem isto o teste trava com o
       cliente sem saber onde digitar. */
    simFocus() {
      this.$nextTick(() => {
        const box = this.$refs.simScroll;
        if (box) box.scrollTop = box.scrollHeight;
        const inp = this.$refs.simInput;
        if (inp && inp.focus) setTimeout(() => inp.focus(), 60);
      });
    },
    titleOf(n) {
      const t = TYPES.find(x => x.type === n.type);
      const txt = (n.text || '').trim();
      return txt ? txt.slice(0, 28) : (t ? t.label : n.type);
    },
    iconOf(n) {
      const t = TYPES.find(x => x.type === n.type);
      return t ? t.icon : '•';
    },
    /* Uma saída por caminho possível: cada botão/item tem a sua (menos os de
       link, que abrem numa aba e não avançam), o carrossel tem uma por botão de
       card, e condição/consulta de oferta têm duas. */
    portsOf(n) {
      if (n.type === 'buttons' || n.type === 'list') {
        return (n.options || []).filter(o => !o.url).map(o => ({ label: o.label, next: o.next }));
      }
      if (n.type === 'carousel') {
        const out = [];
        (n.cards || []).forEach(c => {
          (c.buttons || []).forEach(b => {
            if (!b.url) out.push({ label: `${c.title || 'card'}: ${b.label}`, next: b.next });
          });
        });
        return out;
      }
      if (n.type === 'condition') {
        return [{ label: 'sim', next: n.next }, { label: 'não', next: n.else }];
      }
      if (n.type === 'oferta') {
        return [{ label: 'achou oferta', next: n.next }, { label: 'não achou', next: n.else }];
      }
      if (['ai', 'agent', 'end'].includes(n.type)) return [];
      return [{ label: '', next: n.next }];
    },
    setPort(n, i, targetId) {
      if (this.bloqueadoParaEditar()) return;
      if (n.type === 'buttons' || n.type === 'list') {
        // Opção com link não tem saída, então o índice conta só as que avançam.
        let k = 0;
        (n.options || []).forEach(o => {
          if (o.url) return;
          if (k === i) o.next = targetId;
          k += 1;
        });
      } else if (n.type === 'carousel') {
        let k = 0;
        (n.cards || []).forEach(c => {
          (c.buttons || []).forEach(b => {
            if (b.url) return;
            if (k === i) b.next = targetId;
            k += 1;
          });
        });
      } else if (n.type === 'condition' || n.type === 'oferta') {
        if (i === 0) n.next = targetId; else n.else = targetId;
      } else { n.next = targetId; }
    },
    // E3: NODE_H é só o piso — usa a altura REAL medida do card (cresce com
    // chips de opção quebrando linha; ver registerNodeEl()/nodeHeight()).
    portPos(n, i, total) {
      const step = NODE_W / (total + 1);
      return { x: n.x + step * (i + 1), y: n.y + this.nodeHeight(n) };
    },
    nodeHeight(n) {
      return this.nodeHeights[n.id] || NODE_H;
    },
    /* Callback ref por nó (Vue 3): observa a altura real do `.fnode` (as
       `.fport` são position:absolute, não contam para o auto-height dele,
       então o que medimos é exatamente o `.fcard`). Sem isto, `NODE_H=92`
       fixo deixava a porta de saída/curva parada no offset antigo quando o
       card crescia — ficava por cima dos chips de opção da Lista. */
    registerNodeEl(id, el) {
      if (!this._flowNodeEls) this._flowNodeEls = {};
      const prev = this._flowNodeEls[id];
      if (prev === el) return;
      if (prev && this._flowResizeObserver) this._flowResizeObserver.unobserve(prev);
      this._flowNodeEls[id] = el || null;
      if (!el) return;
      if (!this._flowResizeObserver && typeof ResizeObserver !== 'undefined') {
        this._flowResizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            const nid = entry.target.getAttribute('data-id');
            if (!nid) return;
            const h = Math.max(NODE_H, Math.round(entry.contentRect.height));
            if (this.nodeHeights[nid] !== h) this.nodeHeights[nid] = h;
          });
        });
      }
      if (this._flowResizeObserver) this._flowResizeObserver.observe(el);
    },
    /* Meio da curva — é onde fica a lixeira de desfazer a ligação.
       Bezier cúbica em t=0.5: (P0 + 3P1 + 3P2 + P3) / 8. */
    midBetween(from, i, total, to) {
      const a = this.portPos(from, i, total);
      const b = { x: to.x + NODE_W / 2, y: to.y };
      const dy = Math.max(30, Math.abs(b.y - a.y) / 2);
      const c1 = { x: a.x, y: a.y + dy };
      const c2 = { x: b.x, y: b.y - dy };
      return {
        x: (a.x + 3 * c1.x + 3 * c2.x + b.x) / 8,
        y: (a.y + 3 * c1.y + 3 * c2.y + b.y) / 8,
      };
    },
    /* Desfaz a ligação: some a seta e a saída volta a ficar livre. */
    removeEdge(e) {
      if (this.bloqueadoParaEditar()) return;
      const n = this.nodeById[e.from];
      if (n) this.setPort(n, e.port, null);
    },
    pathBetween(from, i, total, to) {
      const a = this.portPos(from, i, total);
      const b = { x: to.x + NODE_W / 2, y: to.y };
      const dy = Math.max(30, Math.abs(b.y - a.y) / 2);
      return `M ${a.x} ${a.y} C ${a.x} ${a.y + dy}, ${b.x} ${b.y - dy}, ${b.x} ${b.y}`;
    },

    // ---- carga / gravação ------------------------------------------------
    /* Entrega o roteiro para quem embute (a tela de IA do WhatsApp salva tudo
       junto, num POST só — dois botões de salvar na mesma tela é a receita
       clássica de perder trabalho). */
    async loadIa() {
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/ia`,
          { params: { inbox_id: this.inbox.id } }
        );
        this.iaModelo = data.modelo || 'gpt-5-mini';
        this.iaTemChave = !!data.tem_chave;
        this.iaDica = data.chave_dica || '';
      } catch (e) { /* caixa sem config ainda */ }
    },
    async salvarIa() {
      if (this.bloqueadoParaEditar()) return;
      this.iaSalvando = true;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/ia_credencial`,
          { inbox_id: this.inbox.id, modelo: this.iaModelo, chave: this.iaChave }
        );
        this.iaTemChave = !!data.tem_chave;
        this.iaDica = data.chave_dica || '';
        this.iaChave = '';
        useAlert('IA desta caixa salva.');
      } catch (e) {
        useAlert('Não foi possível salvar a IA.');
      }
      this.iaSalvando = false;
    },
    exportFlow() {
      return { enabled: this.enabled, start: this.start, nodes: this.nodes };
    },
    /* E2: defaults comuns para um nó carregado de fora (roteiro salvo OU
       modelo/template) — sem isto, um nó de ação (HTTP/Supabase/Oferta/etc.)
       que veio sem algum campo (o servidor só grava os campos do PRÓPRIO
       type, ver build_flow_node) deixa o painel de edição ler `undefined`
       (ex.: v-for em selected.headers) e quebrar. Usada tanto por `load()`
       quanto por `usarTemplate()`, para as duas vias nunca divergirem. */
    normalizeNode(n) {
      return {
        options: [], cards: [], field: '', error: '', validate: 'texto',
        var: '', op: 'preenchido', value: '', else: null, label: '',
        url: '', src: '', button: 'Ver opções', seconds: 2, agent: '',
        allow_text: true, x: 40, y: 40, text: '', next: null,
        // nós de ação: defaults para o painel não quebrar em roteiro antigo
        metodo: 'GET', headers: [], query: [], body_modo: 'none', body: '',
        timeout_seg: 10, mapear: [], salvar_em: '', code: '', env: {},
        tabela: '', valores: {}, filtros: {}, limit: 10,
        titulo: '', midia: '', botoes: [],
        banco: '', indice: '', form_fields: {},
        auto_digitar: false, // nó "ofertas" antigo (D): sem isto o v-model do toggle não teria valor
        ...n,
      };
    },
    async load() {
      this.loading = true;
      // E3: ids são determinísticos (n1, n2, ...) — sem limpar, um nó novo
      // podia herdar a altura medida de um nó antigo de mesmo id (roteiro
      // anterior), o que descalibra portPos()/fitView() até o próximo
      // ResizeObserver disparar.
      this.nodeHeights = {};
      try {
        // Os dois canais leem da MESMA configuração agora (o roteiro do
        // webchat migra de additional_attributes no primeiro salvamento).
        const rota = this.embedded ? 'mazam_web/ia' : 'mazam_web/flow';
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/${rota}`,
          { params: { inbox_id: this.inbox.id } }
        );
        const f = (this.embedded ? (data.config || {}).flow : data.flow) || {};
        this.enabled = f.enabled === true;
        this.nodes = (f.nodes || []).map(n => this.normalizeNode(n));
        this.start = f.start || (this.nodes[0] ? this.nodes[0].id : '');
        if (!this.nodes.length) this.seed();
        // Roteiro antigo (ou migrado) não tem coordenada: sem isto TODOS os
        // blocos caem no mesmo ponto e ficam empilhados, ilegíveis.
        this.organizarSePreciso();
      } catch (e) {
        this.seed();
      }
      this.loading = false;
    },
    /* Roteiro de exemplo: já sai do zero com um caminho que funciona, para o
       usuário editar em vez de encarar tela em branco. */
    seed() {
      this.nodes = [
        { id: 'n1', type: 'message', x: 60, y: 40, next: 'n2',
          text: 'Sou a Julia, da Mazam. Gostaria de antecipar o saldo do seu FGTS?' },
        { id: 'n2', type: 'buttons', x: 60, y: 200, text: '', field: 'escolha', allow_text: true,
          options: [{ label: 'Sim, quero', next: 'n3' }, { label: 'Ver produtos', next: null }] },
        { id: 'n3', type: 'input', x: 60, y: 360, validate: 'cpf', field: 'cpf', next: 'n4',
          text: 'Perfeito! Me informa seu CPF, por favor.',
          error: 'Esse CPF não confere. Pode revisar?' },
        { id: 'n4', type: 'ai', x: 60, y: 520, text: 'Só um instante, já vou verificar.' },
      ];
      this.start = 'n1';
    },
    async save() {
      if (this.bloqueadoParaEditar()) return;
      this.saving = true;
      try {
        await axios.post(`/api/v1/accounts/${this.accountId}/mazam_web/flow`, {
          inbox_id: this.inbox.id,
          flow: { enabled: this.enabled, start: this.start, nodes: this.nodes },
        });
        useAlert('Roteiro salvo.');
      } catch (e) {
        useAlert('Não foi possível salvar o roteiro.');
      }
      this.saving = false;
    },
    /* E1: botão de salvar DENTRO da toolbar do canvas — fica acessível mesmo em
       tela cheia (a toolbar vive dentro do `.fcanvas`, que já cobre a janela
       toda com z-index alto, então tudo que está nela sobe junto). Embutido
       (caso real de uso, dentro de FlowWhatsappPage), quem salva de verdade é
       o pai: só repassamos o clique. Fora do embed, salva direto como sempre. */
    salvarClique() {
      if (this.bloqueadoParaEditar()) return;
      if (this.embedded) { this.$emit('save'); return; }
      this.save();
    },

    // ---- edição ----------------------------------------------------------
    newId() {
      let i = 1;
      while (this.nodeById[`n${i}`]) i += 1;
      return `n${i}`;
    },
    addNode(type) {
      if (this.bloqueadoParaEditar()) return;
      const id = this.newId();
      const n = {
        id, type, text: '', next: null, options: [], field: '', error: '',
        validate: 'texto', var: '', op: 'preenchido', value: '', else: null,
        label: '', allow_text: true,
        x: Math.round(60 - this.pan.x / this.zoom + 260 * ((this.nodes.length % 3))),
        y: Math.round(60 - this.pan.y / this.zoom + 150 * Math.floor(this.nodes.length / 3)),
      };
      if (type === 'buttons') n.options = [{ label: 'Sim', value: '', next: null }];
      if (type === 'list') {
        n.options = [{ label: 'Opção 1', value: '', description: '', next: null }];
        n.button = 'Ver opções';
      }
      if (type === 'carousel') {
        n.cards = [
          { image: '', title: 'Oferta 1', body: '', buttons: [{ label: 'Quero esta', value: '', url: '', next: null }] },
          { image: '', title: 'Oferta 2', body: '', buttons: [{ label: 'Quero esta', value: '', url: '', next: null }] },
        ];
      }
      if (type === 'link') { n.label = 'Abrir'; n.url = ''; }
      if (type === 'delay') n.seconds = 2;
      if (type === 'ai') n.agent = '';
      if (type === 'input') { n.validate = 'cpf'; n.field = 'cpf'; }
      if (type === 'http') {
        n.metodo = 'GET'; n.url = ''; n.headers = []; n.query = [];
        n.body_modo = 'none'; n.body = ''; n.timeout_seg = 10;
        n.mapear = []; n.salvar_em = 'resposta';
      }
      if (type === 'supabase') {
        n.op = 'inserir'; n.tabela = ''; n.valores = {}; n.filtros = {};
        n.limit = 10; n.salvar_em = 'consulta';
      }
      if (type === 'splash') {
        n.titulo = 'Novidade!';
        n.midia = '';
        n.botoes = [{ label: 'OK', url: '' }];
      }
      if (type === 'script') { n.code = '# vars é o dicionário do fluxo\n# o que você puser em vars volta pro roteiro\n'; n.env = {}; n.salvar_em = 'saida'; }
      if (type === 'oferta') {
        // Lista de bancos vazia = consulta todos os que a caixa tiver liberado.
        n.bancos = []; n.teto_s = OFERTA_TETO_PADRAO; n.salvar_em = 'ofertas';
      }
      if (type === 'ofertas') {
        n.text = 'Olha o que eu consegui pra você:';
        // Auto-digitar (D): default LIGADO — encurta o caminho (escolheu a
        // oferta, já dispara a digitação, sem nó "Digitar" separado). Quem
        // quiser o passo explícito desliga aqui. Mesmo mapa padrão do nó
        // Digitar, pra já vir com ponto de partida.
        n.auto_digitar = true;
        n.form_fields = { ...DIGITAR_FORM_FIELDS_PADRAO };
      }
      if (type === 'digitar') {
        // banco/indice em branco = usa a oferta que o cliente escolheu
        // (escolha_banco/escolha_indice); o mapa já entra com os campos que
        // não têm var de mesmo nome óbvia (ver DIGITAR_FORM_FIELDS_PADRAO).
        n.banco = ''; n.indice = '';
        n.form_fields = { ...DIGITAR_FORM_FIELDS_PADRAO };
      }
      if (type === 'bot') {
        // Padrão = FGTS IA (bot 1), que é o caso de uso que criou este bloco.
        // Deixar em branco também funciona: o servidor usa o padrão dele.
        n.bot_id = BOT_PADRAO.bot_id;
        n.url = BOT_PADRAO.url;
        n.gatilho = BOT_PADRAO.gatilho;
        n.text = 'Vou te passar para a nossa especialista, um instante.';
      }
      if (type === 'trocar_fluxo') {
        // Vazio de propósito: o operador escolhe o modelo no painel. `inicio`
        // vazio = pula só a primeira mensagem (a saudação do modelo).
        n.flow_id = '';
        n.inicio = '';
      }
      this.nodes.push(n);
      if (!this.start) this.start = id;
      this.selectedId = id;
    },
    // ---- modelos de roteiro (templates) ----
    // Ficam FORA da caixa (InstallationConfig global): monta uma vez e reusa em
    // quantas caixas quiser, que é justamente a razão de existirem.
    async carregarTemplates() {
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`);
        this.templates = data.templates || [];
      } catch (e) {
        this.templates = [];
      }
    },
    async salvarTemplate() {
      if (this.bloqueadoParaEditar()) return;
      const nome = window.prompt('Nome do modelo (ex.: "Boas-vindas + CPF"):', '');
      if (!nome || !nome.trim()) return;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`,
          { nome: nome.trim(), flow: { start: this.start, nodes: this.nodes } });
        this.templates = data.templates || [];
        this.tplSel = data.id || '';
        useAlert('Modelo salvo. Já dá para usar em outra caixa.');
      } catch (e) {
        useAlert(e.response?.data?.error || 'Não consegui salvar o modelo.');
      }
    },
    async usarTemplate() {
      if (this.bloqueadoParaEditar()) return;
      const t = this.templates.find(x => x.id === this.tplSel);
      if (!t) return;
      // Substituir o roteiro é destrutivo: confirma antes, dizendo o que perde.
      if (this.nodes.length && !window.confirm(
        `Carregar o modelo "${t.nome}" SUBSTITUI o roteiro que está na tela `
        + `(${this.nodes.length} bloco(s)). Continuar?`)) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`,
          { params: { id: this.tplSel } });
        const f = data.flow || {};
        // E3: limpa ANTES de popular — ids são determinísticos (n1, n2, ...),
        // então sem isto um nó do template podia herdar a altura medida de um
        // nó de mesmo id do roteiro anterior, descalibrando o fitView() logo
        // abaixo (que roda síncrono, antes do ResizeObserver medir de novo).
        this.nodeHeights = {};
        // E2: mesmos defaults de load() (spread raso deixava nó de ação sem
        // campo esperado pelo painel) + SEMPRE reenquadrar — um template
        // salvo já vem com coordenadas próprias, então sem isto o roteiro
        // carregava fora da área visível do canvas sem nenhum aviso.
        this.nodes = (f.nodes || []).map(n => this.normalizeNode(n));
        this.start = f.start || (this.nodes[0] ? this.nodes[0].id : '');
        this.selectedId = null;
        this.fitView();
        useAlert('Modelo carregado. Revise e clique em salvar para valer nesta caixa.');
      } catch (e) {
        useAlert('Não consegui carregar o modelo.');
      }
    },
    /* Marca o modelo escolhido como PADRÃO: toda CAIXA NOVA passa a nascer com
       ele montado e DESLIGADO. Não mexe nas caixas que já existem nem no
       roteiro que está na tela — é só o ponto de partida das próximas. */
    async definirPadrao() {
      if (this.bloqueadoParaDefinirPadrao()) return;
      const t = this.templates.find(x => x.id === this.tplSel);
      if (!t) return;
      if (!window.confirm(
        `Marcar "${t.nome}" como modelo padrão? Toda CAIXA NOVA vai nascer com `
        + 'este roteiro montado e DESLIGADO. As caixas que já existem não mudam.'
      )) return;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates/padrao`,
          { id: this.tplSel, inbox_id: this.inbox?.id });
        this.templates = data.templates || [];
        useAlert('Modelo padrão definido.');
      } catch (e) {
        useAlert(e.response?.data?.error || 'Não consegui definir o padrão.');
      }
    },
    async excluirTemplate() {
      if (this.bloqueadoParaEditar()) return;
      const t = this.templates.find(x => x.id === this.tplSel);
      if (!t) return;
      if (!window.confirm(`Excluir o modelo "${t.nome}"? Isso não afeta os roteiros já salvos nas caixas.`)) return;
      try {
        const { data } = await axios.delete(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`,
          { params: { id: this.tplSel } });
        this.templates = data.templates || [];
        this.tplSel = '';
        useAlert('Modelo excluído.');
      } catch (e) {
        useAlert('Não consegui excluir o modelo.');
      }
    },

    // ---- arquivo do roteiro: EXPORTAR / IMPORTAR JSON (estilo n8n) --------
    // Modelo (template) fica preso à INSTALAÇÃO (InstallationConfig). O arquivo
    // é o que atravessa: leva o roteiro para outra conta, outro servidor, ou
    // simplesmente para o Git/e-mail do cliente.
    //
    // PERMISSÃO (decidido junto com o Controle de Acesso):
    //  · EXPORTAR = leitura → sai também em modo consulta (quem vê o roteiro na
    //    tela já pode copiá-lo; esconder o botão não protegeria nada).
    //  · IMPORTAR = só carrega no CANVAS, então respeita bloqueadoParaEditar().
    //    Nada vai para o servidor aqui: a escrita real continua sendo o
    //    "Salvar roteiro", que passa por require_mazam_admin +
    //    require_mazam_flow_config e por sanitize_flow. Ou seja, um arquivo
    //    malformado nunca vira roteiro salvo sem passar pela validação de lá.

    /* Um bloco do jeito que vai para o arquivo: só os campos do PRÓPRIO tipo
       (espelho de build_flow_node) e sem os segredos que alguém tenha colado à
       mão. Nunca muta this.nodes — tudo é cópia. */
    noParaArquivo(n, avisos) {
      const out = {};
      CAMPOS_COMUNS.forEach(k => { if (n[k] !== undefined) out[k] = n[k]; });
      (CAMPOS_POR_TIPO[n.type] || []).forEach(k => { if (n[k] !== undefined) out[k] = n[k]; });
      // listas: poda item a item (cópias novas)
      Object.keys(CAMPOS_SUB).forEach(k => {
        if (k !== 'buttons' && Array.isArray(out[k])) out[k] = this.podarLista(out[k], CAMPOS_SUB[k]);
      });
      if (Array.isArray(out.cards)) {
        out.cards = out.cards.map(c => ({
          ...c,
          buttons: this.podarLista(c.buttons || [], CAMPOS_SUB.buttons),
        }));
      }
      // dicionários: cópia rasa para não mexer no que está na tela
      ['valores', 'filtros', 'form_fields', 'env'].forEach(k => {
        if (out[k] && typeof out[k] === 'object') out[k] = { ...out[k] };
      });
      if (Array.isArray(out.bancos)) out.bancos = [...out.bancos];

      const onde = `"${this.titleOf(n)}"`;
      if (n.type === 'http') {
        out.headers = this.limparSegredosLista(out.headers || [], `${onde} · cabeçalho`, avisos);
        out.query = this.limparSegredosLista(out.query || [], `${onde} · parâmetro`, avisos);
        // body é payload de negócio: NÃO apagamos sozinho, só apontamos.
        if (RE_SEGREDO_VALOR.test(String(out.body || ''))) {
          avisos.push(`${onde}: o corpo da requisição parece conter uma credencial — revise antes de enviar o arquivo.`);
        }
      }
      if (n.type === 'script') {
        out.env = this.limparSegredosDicionario(out.env || {}, `${onde} · variável de ambiente`, avisos);
        if (RE_SEGREDO_VALOR.test(String(out.code || ''))) {
          avisos.push(`${onde}: o código Python parece ter uma credencial escrita nele — revise antes de enviar o arquivo.`);
        }
      }
      // m5: `valores`/`filtros` (Supabase) e `form_fields` (Digitar/Ofertas)
      // têm o mesmo shape chave->valor que `env` acima e o mesmo risco (um
      // `service_key` colado à mão em `valores` saía inteiro, sem aviso).
      if (n.type === 'supabase') {
        out.valores = this.limparSegredosDicionario(out.valores || {}, `${onde} · valor`, avisos);
        out.filtros = this.limparSegredosDicionario(out.filtros || {}, `${onde} · filtro`, avisos);
      }
      if (n.type === 'ofertas' || n.type === 'digitar') {
        out.form_fields = this.limparSegredosDicionario(out.form_fields || {}, `${onde} · campo`, avisos);
      }
      // URLs que não deveriam atravessar (credencial na query ou endereço
      // interno do nosso cluster, que não existe no servidor de destino).
      [out.url, out.src, out.midia].forEach(u => this.avisarUrl(u, onde, avisos));
      (out.options || []).forEach(o => this.avisarUrl(o.url, onde, avisos));
      (out.botoes || []).forEach(b => this.avisarUrl(b.url, onde, avisos));
      return out;
    },
    podarLista(lista, campos) {
      if (!Array.isArray(lista)) return [];
      return lista.map(item => {
        if (!item || typeof item !== 'object') return item;
        const o = {};
        campos.forEach(k => { if (item[k] !== undefined) o[k] = item[k]; });
        return o;
      });
    },
    /* Segredo de verdade x referência. `{{secret:TOKEN}}` é só um apontador (o
       valor vive na caixa) e passa inteiro — é justamente o jeito certo de
       montar o roteiro. Bearer/sk-/JWT colado à mão, não. */
    pareceSegredo(chave, valor) {
      const v = String(valor == null ? '' : valor);
      if (!v.trim()) return false;
      if (RE_SO_VARIAVEL.test(v)) return false;
      return RE_SEGREDO_CHAVE.test(String(chave || '')) || RE_SEGREDO_VALOR.test(v);
    },
    limparSegredosLista(pares, onde, avisos) {
      return pares.map(p => {
        if (!p || typeof p !== 'object') return p;
        if (!this.pareceSegredo(p.chave, p.valor)) return p;
        avisos.push(`${onde} "${p.chave}": valor removido do arquivo por segurança.`);
        return { ...p, valor: '' };
      });
    },
    limparSegredosDicionario(dic, onde, avisos) {
      const out = {};
      Object.keys(dic || {}).forEach(k => {
        if (this.pareceSegredo(k, dic[k])) {
          avisos.push(`${onde} "${k}": valor removido do arquivo por segurança.`);
          out[k] = '';
        } else { out[k] = dic[k]; }
      });
      return out;
    },
    avisarUrl(url, onde, avisos) {
      const u = String(url || '');
      if (!u) return;
      if (RE_URL_SEGREDO.test(u)) {
        avisos.push(`${onde}: a URL tem credencial no endereço — troque por {{secret:NOME}} antes de compartilhar.`);
      } else if (RE_URL_INTERNA.test(u)) {
        avisos.push(`${onde}: a URL aponta para um endereço interno — não vai funcionar em outro servidor.`);
      }
    },
    /* Envelope do arquivo. NÃO leva identificador de tenant (inbox_id,
       account_id, mazam_code, domínio do cliente) nem chave de IA: um arquivo
       que carrega isso vira vetor de cross-tenant.
       m6 (revisão 2026-08-13): também NÃO leva mais o NOME da caixa em
       `nome`/`origem` — entregar o roteiro do Cliente A ao Cliente B não pode
       revelar de qual cliente ele veio. Quem exporta já sabe de qual caixa
       tirou o arquivo (estava na tela); quem importa vê o nome do ARQUIVO
       escolhido no seletor do próprio sistema operacional (ver
       `aplicarTextoImportado`), não um rótulo vindo de dentro do JSON. */
    flowParaArquivo() {
      const avisos = [];
      const nodes = this.nodes.map(n => this.noParaArquivo(n, avisos));
      const envelope = {
        [ARQUIVO_CHAVE]: ARQUIVO_VERSAO,
        nome: 'Roteiro',
        exportado_em: new Date().toISOString(),
        flow: { enabled: this.enabled === true, start: this.start || '', nodes },
      };
      return { envelope, avisos };
    },
    jsonDoArquivo() {
      const { envelope, avisos } = this.flowParaArquivo();
      return { texto: JSON.stringify(envelope, null, 2), avisos };
    },
    // m6: `slugCaixa()` foi removido, o arquivo exportado nao leva mais o
    // nome da caixa em lugar nenhum (nem no JSON, nem no nome do download,
    // ver `exportarFluxo`).
    mostrarAvisos(titulo, avisos) {
      this.avisosTitulo = avisos.length ? titulo : '';
      this.avisos = avisos;
    },
    /* Baixa o roteiro como arquivo .json.
       Gate: restrito ao super admin (ver `ehSuperAdmin`/mudança de escopo).
       I4 (revisão 2026-08-13): os avisos de segredo são calculados ANTES de
       qualquer escrita — antes o `a.click()` já tinha disparado o download
       quando o aviso aparecia, então o segredo já estava em Downloads e não
       dava para cancelar. Agora, havendo aviso, um confirm pergunta ANTES. */
    exportarFluxo() {
      if (this.bloqueadoParaExportarImportar()) return;
      if (!this.nodes.length) { useAlert('Não há roteiro para exportar.'); return; }
      const { texto, avisos } = this.jsonDoArquivo();
      if (avisos.length && !window.confirm(
        `Este arquivo vai sair com ${avisos.length} ponto(s) de atenção:\n\n`
        + avisos.map(a => `• ${a}`).join('\n')
        + '\n\nExportar mesmo assim?')) return;
      const blob = new Blob([texto], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `fluxo-${new Date().toISOString().slice(0, 10)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // revoga só depois do clique ser processado, senão o Safari baixa vazio
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      this.mostrarAvisos('Arquivo exportado — confira antes de compartilhar:', avisos);
      useAlert(avisos.length
        ? `Roteiro exportado com ${avisos.length} aviso(s) de segurança — a lista fica abaixo do canvas (reduza a tela cheia para ler).`
        : 'Roteiro exportado.');
    },
    /* Copiar o JSON: mesma receita da URL pública em SiteConfigurationPage —
       Clipboard API com queda para textarea (Safari antigo / sem permissão).
       Mesmo gate e mesma inversão de ordem (I4) do exportarFluxo acima. */
    async copiarJson() {
      if (this.bloqueadoParaExportarImportar()) return;
      if (!this.nodes.length) { useAlert('Não há roteiro para copiar.'); return; }
      const { texto, avisos } = this.jsonDoArquivo();
      if (avisos.length && !window.confirm(
        `Este JSON vai sair com ${avisos.length} ponto(s) de atenção:\n\n`
        + avisos.map(a => `• ${a}`).join('\n')
        + '\n\nCopiar mesmo assim?')) return;
      try {
        await navigator.clipboard.writeText(texto);
      } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = texto;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      this.copiado = true;
      setTimeout(() => { this.copiado = false; }, 2000);
      this.mostrarAvisos('JSON copiado — confira antes de compartilhar:', avisos);
      useAlert('JSON do roteiro copiado.');
    },

    // ---- importar --------------------------------------------------------
    abrirImportar() {
      if (this.bloqueadoParaExportarImportar()) return;
      if (this.bloqueadoParaEditar()) return;
      this.importErro = '';
      this.importTexto = '';
      this.avisoCritico = [];
      this.importAberto = true;
    },
    escolherArquivo() {
      if (this.bloqueadoParaExportarImportar()) return;
      if (this.bloqueadoParaEditar()) return;
      const inp = this.$refs.arquivoImport;
      if (inp) inp.click();
    },
    onArquivoImport(ev) {
      const file = ev.target.files && ev.target.files[0];
      // Zera JÁ: sem isto, escolher o MESMO arquivo de novo não dispara
      // `change` e o operador acha que a tela travou. O objeto `file` acima
      // continua válido depois de limpar o input.
      ev.target.value = '';
      if (!file) return;
      if (file.size > ARQUIVO_MAX_BYTES) {
        this.importErro = 'Arquivo grande demais (máximo 512 KB).';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => this.aplicarTextoImportado(String(reader.result || ''), file.name);
      reader.onerror = () => { this.importErro = 'Não consegui ler esse arquivo.'; };
      reader.readAsText(file);
    },
    importarColado() {
      this.aplicarTextoImportado(this.importTexto, 'texto colado');
    },
    aplicarTextoImportado(txt, origem) {
      this.importErro = '';
      let lido;
      try {
        lido = this.lerEnvelope(txt);
      } catch (e) {
        // Erro de arquivo NUNCA derruba a tela: vira mensagem no modal.
        this.importErro = e.message || 'Arquivo inválido.';
        return;
      }
      // m6: prefere o nome do ARQUIVO local (escolhido no seletor do SO, ou
      // "texto colado") ao rótulo que veio DE DENTRO do JSON — depois da
      // correção acima, arquivos novos trazem só "Roteiro" ali mesmo, mas um
      // arquivo antigo (ou editado à mão) ainda pode ter `origem`/`nome` com
      // o nome de outra caixa, e não é isso que deve aparecer no confirm.
      this.carregarFlowDeArquivo(lido.flow, origem || lido.nome);
    },
    /* Aceita 3 formatos, por retrocompatibilidade:
       1. o envelope desta tela: { mazam_flow: 1, flow: {...} }
       2. o que a API devolve:   { enabled, start, nodes }
       3. o que o modelo guarda: { start, nodes }
       Qualquer outra coisa é recusada com mensagem clara. */
    lerEnvelope(txt) {
      const bruto = String(txt || '').trim();
      if (!bruto) throw new Error('Cole o conteúdo do arquivo JSON no campo acima.');
      // I3: `bruto.length` é UTF-16 (unidades de 16 bits) — um roteiro em
      // português com acento passa 30-40% acima dos 512 KB reais antes de
      // bater o teto. `Blob` mede em BYTES, igual ao `file.size` que o outro
      // caminho de entrada (escolher arquivo) já usa.
      const tamanhoBytes = typeof Blob !== 'undefined' ? new Blob([bruto]).size : bruto.length;
      if (tamanhoBytes > ARQUIVO_MAX_BYTES) throw new Error('Conteúdo grande demais (máximo 512 KB).');
      let dados;
      try {
        dados = JSON.parse(bruto);
      } catch (e) {
        throw new Error('Isso não é um JSON válido — confira se copiou o arquivo inteiro.');
      }
      if (!dados || typeof dados !== 'object' || Array.isArray(dados)) {
        throw new Error('JSON válido, mas não é um arquivo de roteiro.');
      }
      const versao = dados[ARQUIVO_CHAVE];
      let flow = null;
      let nome = '';
      if (versao !== undefined) {
        const v = Number(versao);
        // m7: "abc" (NaN) e "0" caíam no MESMO ramo de "versão maior que a
        // lida" — um arquivo simplesmente corrompido lia uma mensagem sobre
        // versão que não fazia sentido nenhum. Separado em dois erros.
        if (!Number.isFinite(v) || v < 1) {
          throw new Error(
            `O campo "${ARQUIVO_CHAVE}" deste arquivo não é um número de `
            + `versão válido (veio "${versao}") — o arquivo parece corrompido `
            + `ou não foi gerado por este editor. Exporte de novo pelo botão `
            + `Exportar.`);
        }
        if (v > ARQUIVO_VERSAO) {
          throw new Error(
            `Arquivo de roteiro na versão ${v}; esta tela lê até a versão `
            + `${ARQUIVO_VERSAO}. Atualize o sistema para importar.`);
        }
        flow = dados.flow;
        nome = dados.nome || dados.origem || '';
      } else if (dados.flow && typeof dados.flow === 'object') {
        flow = dados.flow;
        nome = dados.nome || '';
      } else if (Array.isArray(dados.nodes)) {
        flow = dados;
        nome = 'roteiro sem envelope';
      }
      if (!flow || !Array.isArray(flow.nodes)) {
        throw new Error('Arquivo sem a lista de blocos (flow.nodes). Exporte de novo pelo botão Exportar.');
      }
      if (!flow.nodes.length) throw new Error('O arquivo não tem nenhum bloco.');
      return { flow, nome: nome || 'arquivo' };
    },
    /* I2 (revisão 2026-08-13): normaliza as SUB-estruturas do bloco NA
       ENTRADA, espelhando o que o servidor faz no save (sanitize_flow_*) —
       antes disto, `options:[null]` ou `options:"x"` vindo de um arquivo
       malformado passava direto para `this.nodes` e só quebrava DEPOIS,
       dentro de `portsOf()` (usado por `edges`/`problems`/`organizar()`),
       com o roteiro da tela já substituído e a aba parada até F5. Reusa a
       mesma lista `CAMPOS_SUB` do export — aqui a "poda" é "vira lista de
       objetos válidos", não corte de campo. */
    sanearListaDeObjetos(x) {
      return Array.isArray(x) ? x.filter(i => i && typeof i === 'object' && !Array.isArray(i)) : [];
    },
    sanearNoImportado(n) {
      const out = { ...n };
      Object.keys(CAMPOS_SUB).forEach(k => {
        if (k === 'buttons') return; // 'buttons' só existe ANINHADO em cards, tratado abaixo
        if (out[k] !== undefined) out[k] = this.sanearListaDeObjetos(out[k]);
      });
      if (out.cards !== undefined) {
        out.cards = out.cards.map(c => (
          c && typeof c === 'object'
            ? { ...c, buttons: c.buttons !== undefined ? this.sanearListaDeObjetos(c.buttons) : c.buttons }
            : c
        ));
      }
      ['valores', 'filtros', 'form_fields', 'env'].forEach(k => {
        if (out[k] === undefined) return;
        if (out[k] === null || typeof out[k] !== 'object' || Array.isArray(out[k])) delete out[k];
      });
      ['x', 'y'].forEach(k => {
        if (out[k] === undefined) return;
        const num = Number(out[k]);
        if (!Number.isFinite(num)) { delete out[k]; return; }
        out[k] = Math.max(-20000, Math.min(20000, num)); // mesmo clamp do sanitize_flow (Ruby)
      });
      ['seconds', 'timeout_seg', 'limit'].forEach(k => {
        if (out[k] === undefined) return;
        const num = Number(out[k]);
        if (!Number.isFinite(num)) delete out[k]; else out[k] = num;
      });
      return out;
    },
    /* Um bloco "Botões"/"Lista" sem NENHUMA opção válida (ou "Carrossel" sem
       NENHUM card válido) depois da limpeza acima não é um roteiro parcial
       aceitável — é um menu que o cliente veria sem nada para clicar. Trata
       como os outros descartes (id repetido, tipo desconhecido): vira aviso
       e o bloco não entra no roteiro. */
    blocoFicouInutil(n) {
      if ((n.type === 'buttons' || n.type === 'list') && n.options !== undefined && n.options.length === 0) return true;
      if (n.type === 'carousel' && n.cards !== undefined && n.cards.length === 0) return true;
      return false;
    },
    /* Carrega no CANVAS (não salva). Mesma via de load()/usarTemplate():
       normalizeNode em cada bloco — spread raso deixaria nó de ação sem os
       campos que o painel de edição espera (v-for em selected.headers etc.). */
    carregarFlowDeArquivo(flow, origem) {
      if (this.bloqueadoParaExportarImportar()) return;
      if (this.bloqueadoParaEditar()) return;
      this.avisoCritico = [];
      const avisos = [];
      const vistos = Object.create(null); // m7: id "__proto__"/"constructor" não é tratado como duplicado
      const validos = [];
      flow.nodes.forEach((n, i) => {
        if (!n || typeof n !== 'object') {
          avisos.push(`Bloco ${i + 1} ignorado: formato inesperado.`); return;
        }
        const id = String(n.id == null ? '' : n.id).trim();
        const tipo = String(n.type || '');
        // O servidor descarta isto no save; o canvas precisa descartar ANTES,
        // porque id repetido faz o segundo bloco sobrescrever o primeiro em
        // nodeById (as setas passariam a apontar para o bloco errado) e tipo
        // desconhecido renderiza um card sem rótulo e sem saídas.
        if (!id) { avisos.push(`Bloco ${i + 1} ignorado: sem identificador.`); return; }
        if (vistos[id]) { avisos.push(`Bloco "${id}" ignorado: identificador repetido no arquivo.`); return; }
        if (!TYPES.some(t => t.type === tipo)) {
          avisos.push(`Bloco "${id}" ignorado: tipo "${tipo || '—'}" não existe nesta versão.`); return;
        }
        // I2: só DEPOIS de saber que id/tipo são válidos entramos a limpar as
        // sub-estruturas — sem isto, `options:[null]`/`options:"x"` chegava
        // intacto em `this.nodes` e só explodia dentro de `portsOf()`.
        const saneado = this.sanearNoImportado({ ...n, id, type: tipo });
        if (this.blocoFicouInutil(saneado)) {
          avisos.push(`Bloco "${id}" ignorado: ficou sem opções/cards válidos depois de limpar o arquivo.`);
          return;
        }
        vistos[id] = true;
        validos.push(saneado);
      });
      if (!validos.length) {
        this.importErro = 'Nenhum bloco do arquivo pôde ser aproveitado.';
        return;
      }
      // I3: mesmo teto que o servidor grava (ARQUIVO_MAX_BLOCOS = FLOW_MAX_NODES
      // no Ruby) — recusa ANTES de tocar this.nodes, em vez de só avisar depois
      // (15 mil blocos travam a aba muito antes de chegar perto do "Salvar").
      if (validos.length > ARQUIVO_MAX_BLOCOS) {
        this.importErro = `Este arquivo tem ${validos.length} blocos; o limite é ${ARQUIVO_MAX_BLOCOS}.`;
        return;
      }

      // C1: nó "script" carrega código Python que o motor EXECUTA de verdade
      // (mazam-webchat/_exec_script -> py_runner exec()). Um arquivo .json é
      // canal EXTERNO, então antes de aplicar no canvas o operador revê o
      // código à vista — não basta um confirm genérico.
      const blocosScript = validos.filter(n => n.type === 'script' && String(n.code || '').trim());
      if (blocosScript.length) {
        this.importScriptPendente = {
          flow, origem, validos, avisos,
          blocos: blocosScript.map(n => ({ titulo: this.titleOf(n), code: String(n.code || '') })),
        };
        return; // aguarda confirmarImportComCodigo()/cancelarImportComCodigo()
      }
      this.finalizarImportacao(flow, origem, validos, avisos, false);
    },
    /* C1: só chega aqui depois que o operador leu o código à vista no modal
       e decidiu prosseguir mesmo assim. `pularConfirmSubstituir=true` porque
       o próprio modal do código já deixou claro que isto substitui o roteiro
       da tela — perguntar de novo com um confirm genérico seria ruído. */
    confirmarImportComCodigo() {
      const pend = this.importScriptPendente;
      if (!pend) return;
      this.importScriptPendente = null;
      this.finalizarImportacao(pend.flow, pend.origem, pend.validos, pend.avisos, true);
    },
    cancelarImportComCodigo() {
      this.importScriptPendente = null;
    },
    /* I2: monta o estado novo em variáveis LOCAIS (novosNodes/ids/inicio) e só
       atribui a this.nodes/this.start no final, dentro de um try/catch que
       DESFAZ tudo se qualquer coisa falhar (organizarSePreciso/fitView
       incluídos — é onde o bug original explodia, depois de já ter trocado o
       roteiro da tela). Erro nunca deixa a tela pior do que estava. */
    finalizarImportacao(flow, origem, validos, avisosEntrada, pularConfirmSubstituir) {
      // Substituir o roteiro é destrutivo: confirma antes, dizendo o que perde
      // (pulado quando o modal de código acima já cobriu essa confirmação).
      if (!pularConfirmSubstituir && this.nodes.length && !window.confirm(
        `Importar "${origem}" SUBSTITUI o roteiro que está na tela `
        + `(${this.nodes.length} bloco(s)). Continuar?`)) return;

      const nodesAntes = this.nodes;
      const startAntes = this.start;
      const alturasAntes = this.nodeHeights;
      try {
        const novosNodes = validos.map(n => this.normalizeNode(n));
        const ids = novosNodes.map(n => n.id);
        const inicioArq = String(flow.start || '');
        const inicio = ids.includes(inicioArq) ? inicioArq : novosNodes[0].id;
        if (!ids.includes(inicioArq) && inicioArq) {
          avisosEntrada.push(`O bloco inicial "${inicioArq}" não veio no arquivo; usei "${inicio}".`);
        }
        // E3: limpa ANTES de popular — ids são determinísticos (n1, n2, ...),
        // e sem isto um bloco do arquivo herdaria a altura medida do bloco de
        // mesmo id do roteiro anterior, descalibrando portPos()/fitView().
        this.nodeHeights = {};
        this.nodes = novosNodes;
        this.start = inicio;
        // `enabled` NÃO vem do arquivo de propósito: publicar na hora um
        // roteiro de outra caixa, sem revisão, é o pior padrão possível.
        // Fica como está nesta caixa e o operador liga quando quiser.
        this.selectedId = null;
        // Arquivo sem coordenadas (ou com tudo no mesmo ponto) fica ilegível;
        // com coordenadas próprias, só reenquadra.
        this.organizarSePreciso();
        this.fitView();
        // só fecha o modal quando o roteiro terminou de aplicar sem erro —
        // se algo falhar lá em cima, o operador continua vendo o modal com o
        // erro, em vez de uma tela quebrada e o modal já fechado.
        this.importAberto = false;
        this.importTexto = '';
      } catch (e) {
        this.nodes = nodesAntes;
        this.start = startAntes;
        this.nodeHeights = alturasAntes;
        this.importErro = 'Não consegui carregar esse arquivo: formato inválido. Nada foi alterado no roteiro atual.';
        return;
      }

      // C1: o que este roteiro EXECUTA/CHAMA quando tocar cada bloco — vem
      // ANTES e com destaque próprio (avisoCritico), não misturado na lista
      // âmbar de baixo.
      this.avisoCritico = this.avisosDeExecucao(this.nodes);
      const outrosAvisos = [...avisosEntrada, ...this.avisosDeImportacao(this.nodes)];
      this.mostrarAvisos('Importado — revise estes pontos antes de salvar:', outrosAvisos);
      useAlert(outrosAvisos.length
        ? `Roteiro importado com ${outrosAvisos.length} ponto(s) a revisar. Confira a lista e clique em Salvar roteiro.`
        : 'Roteiro importado. Revise e clique em Salvar roteiro para valer nesta caixa.');
    },
    /* C1: o que EXECUTA/CHAMA rede quando o roteiro tocar o bloco — código do
       nó "script", host do nó "http", destino do nó "bot". Não esvazia nada
       aqui (isso já aconteceu, se necessário, no fluxo do "script" acima):
       é só informativo, mas destacado e sempre ANTES dos demais avisos. */
    avisosDeExecucao(nodes) {
      const out = [];
      const scripts = nodes.filter(n => n.type === 'script' && String(n.code || '').trim());
      if (scripts.length) {
        out.push(`${scripts.length} bloco(s) "Script" trazem código Python que o servidor executa — revisado antes de importar.`);
      }
      nodes.forEach(n => {
        const onde = `"${this.titleOf(n)}"`;
        if (n.type === 'http' && String(n.url || '').trim()) {
          out.push(`${onde}: ao rodar, este bloco chama a URL "${n.url}".`);
        }
        if (n.type === 'bot' && (String(n.url || '').trim() || n.bot_id)) {
          const destino = String(n.url || '').trim() ? `"${n.url}"` : `bot #${n.bot_id}`;
          out.push(`${onde}: ao rodar, este bloco transfere a conversa para ${destino}.`);
        }
      });
      return out;
    },
    /* O que NÃO atravessa de caixa/servidor. Nada disso é segredo — mas cala
       em runtime se ninguém conferir, então é melhor dizer na hora. */
    avisosDeImportacao(nodes) {
      const out = [];
      nodes.forEach(n => {
        const onde = `"${this.titleOf(n)}"`;
        if (n.type === 'bot' && (n.bot_id || n.url)) {
          out.push(`${onde}: o id/URL da IA de destino é desta instalação — confirme qual IA deve receber a conversa aqui.`);
        }
        if (n.type === 'ai' && n.agent && !(this.agentesIa || []).some(a => a.id === n.agent)) {
          out.push(`${onde}: a IA "${n.agent}" não existe nesta caixa — vai cair na IA padrão.`);
        }
        if (n.type === 'supabase' && n.tabela) {
          out.push(`${onde}: a tabela "${n.tabela}" precisa estar liberada nesta caixa para o bloco funcionar.`);
        }
        if (n.type === 'oferta' && (n.bancos || []).length) {
          out.push(`${onde}: os bancos ${n.bancos.join(', ')} só respondem se esta caixa tiver credencial deles.`);
        }
        if (['digitar', 'ofertas'].includes(n.type) && Object.keys(n.form_fields || {}).length) {
          out.push(`${onde}: confira se os blocos "Pedir dado" deste roteiro guardam as variáveis do mapa de campos.`);
        }
        if (n.type === 'http' && (n.headers || []).some(h => h && h.valor === '')) {
          out.push(`${onde}: há cabeçalho sem valor (removido na exportação) — preencha com {{secret:NOME}}.`);
        }
      });
      return out;
    },
    // ---- organização automática dos blocos ----
    // Só reposiciona quando é necessário: roteiro sem coordenada (formato
    // antigo/migrado) ou com todos os blocos no mesmo ponto. Um roteiro que o
    // usuário já arrumou à mão NÃO é mexido.
    organizarSePreciso() {
      if (!this.nodes.length) return;
      const semCoord = this.nodes.some(
        n => n.x === null || n.x === undefined || n.y === null || n.y === undefined
      );
      const primeiros = `${this.nodes[0].x},${this.nodes[0].y}`;
      const todosIguais = this.nodes.every(n => `${n.x},${n.y}` === primeiros);
      if (semCoord || (this.nodes.length > 1 && todosIguais)) this.organizar();
    },
    /* Arruma em colunas por PROFUNDIDADE: cada passo do roteiro anda para a
       direita, e caminhos paralelos (botões/condição) descem em linhas. Assim o
       desenho fica na ordem em que a conversa acontece. */
    organizar() {
      if (this.bloqueadoParaEditar()) return;
      const COL = 300;
      const LIN = 170;
      const nivel = {};
      const fila = [];
      const inicio = this.nodeById[this.start] ? this.start : this.nodes[0].id;
      nivel[inicio] = 0;
      fila.push(inicio);
      let guard = 0;
      while (fila.length && guard < 400) {
        guard += 1;
        const id = fila.shift();
        this.portsOf(this.nodeById[id] || {}).forEach(p => {
          if (p.next && this.nodeById[p.next] && nivel[p.next] === undefined) {
            nivel[p.next] = nivel[id] + 1;
            fila.push(p.next);
          }
        });
      }
      // Bloco solto (ninguém aponta pra ele) vai para uma coluna extra ao lado.
      const maxNivel = Math.max(0, ...Object.values(nivel));
      this.nodes.forEach(n => {
        if (nivel[n.id] === undefined) nivel[n.id] = maxNivel + 1;
      });
      const usadosPorColuna = {};
      this.nodes
        .slice()
        .sort((a, b) => nivel[a.id] - nivel[b.id])
        .forEach(n => {
          const c = nivel[n.id];
          usadosPorColuna[c] = (usadosPorColuna[c] || 0);
          n.x = 60 + c * COL;
          n.y = 60 + usadosPorColuna[c] * LIN;
          usadosPorColuna[c] += 1;
        });
      this.fitView();
    },
    // ---- nós de ação: helpers de UI ----
    // Objeto {k:v} <-> texto "k=v" por linha (valores/filtros/env).
    // Vídeo (arquivo ou YouTube) não tem prévia de imagem no editor.
    ehVideo(u) {
      return /\.(mp4|webm|ogg|mov)(\?|$)/i.test(u || '') || /youtu\.?be|youtube\.com/i.test(u || '');
    },
    kvText(obj) {
      if (!obj || typeof obj !== 'object') return '';
      return Object.entries(obj).map(([k, v]) => `${k}=${v}`).join('\n');
    },
    setKv(node, campo, texto) {
      if (this.bloqueadoParaEditar()) return;
      const out = {};
      String(texto || '').split('\n').forEach(linha => {
        const i = linha.indexOf('=');
        if (i > 0) {
          const k = linha.slice(0, i).trim();
          if (k) out[k] = linha.slice(i + 1).trim();
        }
      });
      node[campo] = out;
    },
    // Task D: bancos ATIVOS desta caixa (com credencial cadastrada) — mesmo
    // proxy que a Central de Simulação já usa (simuladorApi -> Rails
    // simulador_api_controller#proxy -> simulador-api:8811/api/bancos-habilitados).
    // Formato "adapters" devolve no nível de adapter já com label amigável
    // ({id,nome}), pronto pro checkbox. Falha (serviço fora do ar OU rota
    // ainda não liberada no proxy) cai na lista fixa BANCOS, pra não deixar
    // o seletor vazio — mas o normal é vir da caixa (multi-tenant de verdade).
    async carregarBancos() {
      try {
        const { data } = await simuladorApi.get('bancos-habilitados', {
          inbox_id: this.inbox.id,
          formato: 'adapters',
        });
        // Review F2: `formato=adapters` é da Task C (simulador-api), que pode
        // ainda não estar no ar quando este editor sobe — sem checar o SHAPE
        // dos itens, um retorno no formato ANTIGO (array de strings cruas,
        // ex. "soma_cel") passava no `Array.isArray` e caía direto no
        // v-for com `b.id`/`b.nome`, que renderizava undefined em silêncio
        // (sem erro, sem cair no catch/fallback). Só aceita se TODO item já
        // vier `{id: string, ...}` — qualquer coisa fora disso é tratada como
        // falha e cai no mesmo fallback fixo do catch abaixo.
        const lista = data?.bancos;
        const shapeOk = Array.isArray(lista) && lista.every(b => b && typeof b.id === 'string');
        if (!shapeOk) throw new Error('bancos-habilitados: formato inesperado (Task C ainda não no ar?)');
        this.bancosDisponiveis = lista;
      } catch (e) {
        this.bancosDisponiveis = BANCOS;
      }
    },
    // Nome amigável de um banco marcado no nó — procura primeiro nos bancos
    // ATIVOS da caixa (lista atual) e cai na lista fixa se o banco marcado
    // não estiver mais ativo (ex.: caixa perdeu a credencial depois de salvo,
    // ou é o fallback fixo) — sem isto a prioridade mostraria só o id cru.
    nomeBanco(id) {
      const achou = (this.bancosDisponiveis || []).find(b => b.id === id)
        || BANCOS.find(b => b.id === id);
      return achou ? achou.nome : id;
    },
    // Prioridade (D): a ORDEM do array `bancos` do nó É a prioridade — subir/
    // descer só troca a posição de dois vizinhos, retrocompatível (roteiro
    // antigo sem prioridade nenhuma continua funcionando, só que sem ordem
    // explícita — o `sanitize_flow_bancos` do servidor preserva a ordem tal
    // como chega, nunca reordena).
    moverBanco(n, i, delta) {
      if (this.bloqueadoParaEditar()) return;
      const arr = n.bancos;
      const j = i + delta;
      if (!Array.isArray(arr) || j < 0 || j >= arr.length) return;
      [arr[i], arr[j]] = [arr[j], arr[i]];
    },
    // Pré-preenche `form_fields` do nó "ofertas" com o mesmo padrão do nó
    // "Digitar proposta" (DIGITAR_FORM_FIELDS_PADRAO) quando ainda está
    // vazio — chamado tanto ao ABRIR um nó antigo com auto_digitar já ligado
    // (watch: selectedId) quanto ao LIGAR o toggle na hora, sem trocar de nó
    // (watch: 'selected.auto_digitar') — ver review F3.
    garantirFormFieldsOfertas(n) {
      if (!Object.keys(n.form_fields || {}).length) {
        n.form_fields = { ...DIGITAR_FORM_FIELDS_PADRAO };
      }
    },
    // Correção 2 (auditoria 2026-08-12): quais chaves de `form_fields` de um
    // nó auto-digitar/"digitar" NÃO têm nenhum bloco "Pedir dado" (input) no
    // roteiro alimentando a variável esperada. `form_fields` é
    // `{campo_do_banco: variável_do_fluxo}` (ver textarea do painel acima) —
    // o que precisa existir é um nó `input` com `field` igual à VARIÁVEL
    // (lado direito); também aceita a própria CHAVE como fallback, para não
    // acusar falso positivo em roteiro simples que nomeou a variável igual
    // ao campo do banco (caso comum: nascimento=nascimento). Checagem por
    // PRESENÇA no fluxo inteiro (não por alcançabilidade) — é aviso
    // preventivo, não grafo perfeito.
    camposFormFieldsSemColeta(n) {
      const coletados = new Set(
        this.nodes.filter(x => x.type === 'input' && (x.field || '').trim()).map(x => x.field.trim())
      );
      const faltando = new Set();
      Object.entries(n.form_fields || {}).forEach(([chave, variavel]) => {
        const alvo = (variavel || '').trim() || chave;
        if (!coletados.has(alvo) && !coletados.has(chave)) {
          faltando.add(this.rotuloCampoFormField(chave));
        }
      });
      return Array.from(faltando);
    },
    // Rótulo amigável por chave de form_fields: agrupa os campos aninhados
    // (endereco.*/recebimento.*) num único item legível na lista de avisos
    // e no selo do card, em vez de listar cada sub-campo separado.
    rotuloCampoFormField(chave) {
      if (chave.startsWith('endereco.')) return 'endereço';
      if (chave.startsWith('recebimento.')) return 'PIX ou conta';
      return chave;
    },
    async carregarTabelas(preselecionada) {
      this.sbCarregando = true;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/supabase_tabelas`,
          { params: { inbox_id: this.inbox.id } });
        this.sbTabelas = data.liberadas || [];
        if (preselecionada) await this.carregarColunas(preselecionada);
      } catch (e) {
        this.sbTabelas = [];
      } finally {
        this.sbCarregando = false;
      }
    },
    async carregarColunas(tabela) {
      this.sbColunas = [];
      if (!tabela) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/supabase_colunas`,
          { params: { inbox_id: this.inbox.id, tabela } });
        this.sbColunas = data.colunas || [];
      } catch (e) { /* tabela vazia/sem permissão: segue sem dica */ }
    },
    async testarAcao(node) {
      if (this.bloqueadoParaEditar()) return;
      this.acaoTestando = true;
      this.acaoResultado = '';
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/acao_test`,
          { inbox_id: this.inbox.id, node, vars: {} });
        this.acaoResultado = JSON.stringify(data, null, 2);
      } catch (e) {
        this.acaoResultado = 'Falhou: ' + (e.response?.data?.erro || e.message);
      } finally {
        this.acaoTestando = false;
      }
    },
    removeNode(id) {
      if (this.bloqueadoParaEditar()) return;
      this.nodes = this.nodes.filter(n => n.id !== id);
      this.nodes.forEach(n => {
        if (n.next === id) n.next = null;
        if (n.else === id) n.else = null;
        (n.options || []).forEach(o => { if (o.next === id) o.next = null; });
      });
      if (this.start === id) this.start = this.nodes[0] ? this.nodes[0].id : '';
      if (this.selectedId === id) this.selectedId = null;
    },
    addOption(n) {
      if (this.bloqueadoParaEditar()) return;
      const max = MAX_OPTIONS[n.type] || 3;
      if ((n.options || []).length >= max) return;
      n.options.push({ label: 'Nova opção', value: '', description: '', next: null });
    },
    maxOptions(n) { return MAX_OPTIONS[n.type] || 3; },
    addCard(n) {
      if (this.bloqueadoParaEditar()) return;
      if ((n.cards || []).length >= MAX_CARDS) return;
      // A Meta exige a MESMA quantidade de botões em todos os cards; o card novo
      // já nasce copiando os rótulos do primeiro para não sair torto.
      const base = (n.cards[0] && n.cards[0].buttons) || [{ label: 'Quero esta' }];
      n.cards.push({
        image: '', title: `Oferta ${n.cards.length + 1}`, body: '',
        buttons: base.map(b => ({ label: b.label, value: '', url: '', next: null })),
      });
    },
    addCardButton(n) {
      if (this.bloqueadoParaEditar()) return;
      if (!n.cards.length || n.cards[0].buttons.length >= 2) return;
      n.cards.forEach(c => c.buttons.push({ label: 'Novo botão', value: '', url: '', next: null }));
    },
    removeCardButton(n, i) {
      if (this.bloqueadoParaEditar()) return;
      n.cards.forEach(c => c.buttons.splice(i, 1));
    },

    // ---- canvas ----------------------------------------------------------
    toCanvas(ev) {
      const r = this.$refs.canvas.getBoundingClientRect();
      return {
        x: (ev.clientX - r.left - this.pan.x) / this.zoom,
        y: (ev.clientY - r.top - this.pan.y) / this.zoom,
      };
    },
    onNodeDown(ev, n) {
      if (ev.button !== 0) return;
      ev.stopPropagation();
      this.selectedId = n.id;
      // Consulta: clicar SELECIONA o bloco (para inspecionar os campos, que
      // vêm desabilitados), mas não arrasta — e sem alerta, senão todo clique
      // de leitura viraria toast.
      if (this.soLeitura) return;
      const p = this.toCanvas(ev);
      this.drag = { id: n.id, dx: p.x - n.x, dy: p.y - n.y };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    },
    onPortDown(ev, n, i) {
      if (this.bloqueadoParaEditar()) return;
      ev.stopPropagation();
      const p = this.toCanvas(ev);
      this.linking = { from: n.id, port: i, x: p.x, y: p.y };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    },
    onCanvasDown(ev) {
      if (ev.target.closest('.fnode')) return;
      this.selectedId = null;
      this.panning = { x: ev.clientX - this.pan.x, y: ev.clientY - this.pan.y };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    },
    onMove(ev) {
      if (this.drag) {
        const p = this.toCanvas(ev);
        const n = this.nodeById[this.drag.id];
        if (n) {
          n.x = Math.round((p.x - this.drag.dx) / 10) * 10;   // encaixa na grade
          n.y = Math.round((p.y - this.drag.dy) / 10) * 10;
        }
      } else if (this.linking) {
        const p = this.toCanvas(ev);
        this.linking.x = p.x; this.linking.y = p.y;
      } else if (this.panning) {
        this.pan.x = ev.clientX - this.panning.x;
        this.pan.y = ev.clientY - this.panning.y;
      }
    },
    onUp(ev) {
      if (this.linking) {
        const el = document.elementFromPoint(ev.clientX, ev.clientY);
        const card = el && el.closest ? el.closest('.fnode') : null;
        const targetId = card ? card.getAttribute('data-id') : null;
        const from = this.nodeById[this.linking.from];
        if (from && targetId && targetId !== from.id) {
          this.setPort(from, this.linking.port, targetId);
        }
      }
      this.drag = null; this.panning = null; this.linking = null;
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
    },
    onWheel(ev) {
      ev.preventDefault();
      this.zoomBy(ev.deltaY < 0 ? 1.1 : 0.9);
    },
    /* Zoom pelo centro da área visível: sem isto o desenho "foge" para o canto
       toda vez que aproxima. */
    zoomBy(factor) {
      const el = this.$refs.canvas;
      const w = el ? el.clientWidth : 800;
      const h = el ? el.clientHeight : 460;
      const next = Math.min(2, Math.max(0.3, this.zoom * factor));
      const k = next / this.zoom;
      this.pan.x = w / 2 - (w / 2 - this.pan.x) * k;
      this.pan.y = h / 2 - (h / 2 - this.pan.y) * k;
      this.zoom = next;
    },
    /* Enquadra o roteiro inteiro na tela — indispensável quando o fluxo cresce. */
    fitView() {
      if (!this.nodes.length) return;
      const el = this.$refs.canvas;
      const w = el ? el.clientWidth : 800;
      const h = el ? el.clientHeight : 460;
      const xs = this.nodes.map(n => n.x);
      const ys = this.nodes.map(n => n.y);
      const minX = Math.min(...xs);
      const minY = Math.min(...ys);
      const maxX = Math.max(...xs) + NODE_W;
      // E3: usa a altura real de cada card (pode passar de NODE_H com
      // chips de opção quebrando linha), não um valor fixo para todos.
      const maxY = Math.max(...this.nodes.map(n => n.y + this.nodeHeight(n))) + 30;
      const pad = 60;
      const z = Math.min(1.4, Math.max(0.3,
        Math.min((w - pad * 2) / (maxX - minX), (h - pad * 2) / (maxY - minY))));
      this.zoom = z;
      this.pan.x = (w - (maxX - minX) * z) / 2 - minX * z;
      this.pan.y = (h - (maxY - minY) * z) / 2 - minY * z;
    },
    linkPath() {
      const l = this.linking;
      const from = this.nodeById[l.from];
      if (!from) return '';
      const a = this.portPos(from, l.port, this.portsOf(from).length);
      return `M ${a.x} ${a.y} L ${l.x} ${l.y}`;
    },

    // ---- simulador -------------------------------------------------------
    /* Roda o roteiro aqui mesmo, sem publicar nada — mesma lógica do motor do
       servidor, para conferir o caminho antes de colocar no ar. */
    startSim() {
      this.sim = { log: [], node: null, done: false };
      this.simRun(this.start, {});
    },
    simRun(id, vars) {
      let cur = id;
      let guard = 0;
      while (cur && guard < 25) {
        guard += 1;
        const n = this.nodeById[cur];
        if (!n) break;
        if (n.text) this.sim.log.push({ who: 'bot', text: this.simText(n.text, vars) });
        if (n.type === 'message') { cur = n.next; continue; }
        if (n.type === 'delay') {
          this.sim.log.push({ who: 'sys', text: `⏳ digitando por ${n.seconds || 2}s` });
          cur = n.next; continue;
        }
        if (n.type === 'image') {
          this.sim.log.push({ who: 'sys', text: `🖼️ imagem: ${n.src || '(sem URL)'}` });
          cur = n.next; continue;
        }
        if (n.type === 'link') {
          this.sim.log.push({ who: 'bot', text: `🔗 ${n.label || 'Abrir'} → ${this.simText(n.url, vars)}` });
          cur = n.next; continue;
        }
        if (n.type === 'condition') { cur = vars[n.var] ? n.next : n.else; continue; }
        if (n.type === 'list') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'carousel') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'buttons') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'input') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'splash') { this.sim.log.push({ who: 'sys', text: `✨ destaque: ${n.titulo || '(sem título)'}${n.midia ? ' + mídia' : ''}` }); cur = n.next; continue; }
        if (n.type === 'http') { this.sim.log.push({ who: 'sys', text: `🌐 HTTP ${n.metodo || 'GET'} → salva em {{${n.salvar_em || 'resposta'}}} (use ▶ Testar p/ rodar de verdade)` }); cur = n.next; continue; }
        if (n.type === 'supabase') { this.sim.log.push({ who: 'sys', text: `🗄️ Supabase ${n.op || 'inserir'} em ${n.tabela || '(tabela)'} (use ▶ Testar p/ rodar de verdade)` }); cur = n.next; continue; }
        if (n.type === 'script') { this.sim.log.push({ who: 'sys', text: `🐍 Script → salva em {{${n.salvar_em || 'saida'}}} (use ▶ Testar p/ rodar de verdade)` }); cur = n.next; continue; }
        if (n.type === 'oferta') {
          const quais = (n.bancos || []).length ? n.bancos.join(', ') : 'todos os bancos liberados';
          this.sim.log.push({ who: 'sys', text: `💰 consulta oferta em ${quais} (até ${n.teto_s || OFERTA_TETO_PADRAO}s) → salva em {{${n.salvar_em || 'ofertas'}}}. Aqui o teste segue pela saída "achou oferta".` });
          cur = n.next; continue;
        }
        if (n.type === 'ofertas') {
          const auto = n.auto_digitar ? ' e já dispara a digitação do banco escolhido (auto-digitar ligado)' : '';
          this.sim.log.push({ who: 'sys', text: `🏷️ mostra os cards das ofertas encontradas e espera o cliente escolher${auto}` });
          cur = n.next; continue;
        }
        if (n.type === 'bot') {
          // A fala (n.text) já foi para o log lá em cima, junto com a de
          // qualquer outro bloco — aqui entra só o que a transferência faz.
          this.sim.log.push({ who: 'sys', text: `🤖 entrega a conversa para a IA ${n.bot_id || '(padrão)'} e manda o gatilho “${this.simText(n.gatilho, vars) || '(padrão)'}”. Aqui o teste segue pela saída, como se tivesse dado certo.` });
          cur = n.next; continue;
        }
        if (n.type === 'ai') { this.sim.log.push({ who: 'sys', text: '→ IA assume a conversa' }); break; }
        if (n.type === 'agent') { this.sim.log.push({ who: 'sys', text: '→ atendente humano assume' }); break; }
        if (n.type === 'end') { this.sim.log.push({ who: 'sys', text: '→ roteiro encerrado' }); break; }
        break;
      }
      this.sim.node = null;
      this.sim.done = true;
      this.simFocus();
    },
    simText(t, vars) {
      return String(t || '').replace(/\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g, (m, k) => vars[k] || '');
    },
    simPick(opt) {
      const n = this.sim.node;
      const vars = { ...n.vars };
      // Grava o valor interno quando existe — igual ao motor do servidor.
      if (n.field) vars[n.field] = opt.value || opt.label;
      this.sim.log.push({ who: 'cli', text: opt.echo || opt.label });
      this.sim.node = null;
      this.simRun(opt.next, vars);
    },
    /* Escolhas do passo atual, na MESMA ordem que o servidor usa (botões de
       link não entram, porque abrem numa aba e não avançam o roteiro). */
    simChoices(n) {
      if (!n) return [];
      if (n.type === 'carousel') {
        const out = [];
        (n.cards || []).forEach(c => {
          (c.buttons || []).forEach(b => {
            if (b.url) return;
            out.push({ ...b, echo: `${c.title || 'card'} — ${b.label}` });
          });
        });
        return out;
      }
      return (n.options || []).filter(o => !o.url);
    },
    simSend(value) {
      const n = this.sim.node;
      const vars = { ...n.vars };
      if (!this.simValid(n.validate, value)) {
        this.sim.log.push({ who: 'cli', text: value });
        this.sim.log.push({ who: 'bot', text: n.error || 'Não consegui validar. Confere pra mim?' });
        this.simFocus();
        return;
      }
      vars[n.field || 'resposta'] = value;
      this.sim.log.push({ who: 'cli', text: value });
      this.sim.node = null;
      this.simRun(n.next, vars);
    },
    simValid(kind, v) {
      v = (v || '').trim();
      if (kind === 'cpf') {
        const c = v.replace(/\D/g, '');
        if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
        let t = 0;
        for (let i = 0; i < 9; i += 1) t += parseInt(c[i], 10) * (10 - i);
        let r = t % 11;
        if (parseInt(c[9], 10) !== (r < 2 ? 0 : 11 - r)) return false;
        t = 0;
        for (let i = 0; i < 10; i += 1) t += parseInt(c[i], 10) * (11 - i);
        r = t % 11;
        return parseInt(c[10], 10) === (r < 2 ? 0 : 11 - r);
      }
      if (kind === 'email') return /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/.test(v);
      if (kind === 'telefone') { const d = v.replace(/\D/g, ''); return d.length === 10 || d.length === 11; }
      if (kind === 'numero') return /\d/.test(v);
      // Daqui para baixo: as MESMAS regras do motor (mazam-webchat `flow.validate`).
      // Sem elas o simulador aprovava o que a produção recusa — o operador testava
      // o roteiro aqui, via passar, e o cliente real levava a mensagem de erro.
      if (kind === 'cep') return v.replace(/\D/g, '').length === 8;
      if (kind === 'uf') return /^[A-Za-z]{2}$/.test(v);
      if (kind === 'banco') { const d = v.replace(/\D/g, ''); return d.length >= 1 && d.length <= 3; }
      if (kind === 'agencia') { const d = v.replace(/\D/g, ''); return d.length >= 1 && d.length <= 5; }
      if (kind === 'conta') { const d = v.replace(/\D/g, ''); return d.length >= 1 && d.length <= 12; }
      if (kind === 'digito') return /^[0-9xX]$/.test(v.replace(/\s/g, ''));
      return v.length > 0;
    },
  },
};
</script>

<template>
  <div class="mx-6">
    <h3 v-if="!embedded" class="text-base font-semibold mb-1">Fluxo de atendimento</h3>
    <p v-if="!embedded" class="text-sm text-slate-500 dark:text-slate-400 mb-4">
      Monte o roteiro que o cliente vê ao abrir o site: mensagem, botões e coleta de
      dados com validação. Quando o cliente perguntar algo fora do roteiro, a conversa
      passa para a IA automaticamente, com todo o histórico.
    </p>

    <label style="display:flex;align-items:center;gap:8px;cursor:pointer" class="mb-2">
      <input v-model="enabled" type="checkbox" style="margin:0" :disabled="soLeitura" />
      <span class="text-sm font-medium">Ativar este roteiro</span>
      <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
            :style="enabled ? 'background:rgba(0,168,132,.18);color:#0f7c63'
                            : 'background:rgba(148,163,184,.2)'">
        {{ enabled ? 'roteiro conduz a conversa' : 'roteiro desligado' }}
      </span>
    </label>
    <p v-if="embedded" class="mb-4 text-xs text-slate-500">
      Com o roteiro ligado, ele conduz e só passa para a IA nos blocos
      "Passar para IA". Desligado, quem responde é a IA padrão da caixa.
    </p>
    <p v-if="!embedded && !enabled" class="text-xs text-slate-500 mb-4">
      Desligado, a caixa segue como hoje: saudação automática e IA respondendo tudo.
    </p>

    <div v-if="!embedded && !soLeitura" class="p-4 mb-4 rounded-lg" style="background:rgba(148,163,184,.08)">
      <p class="mb-1 text-sm font-semibold">🤖 IA desta caixa</p>
      <p class="mb-3 text-xs text-slate-500">
        Usada no bloco "Passar para IA" e quando o cliente perguntar algo fora do
        roteiro. Cada caixa tem a sua chave — assim dá para separar o custo e
        revogar uma sem afetar as outras.
      </p>
      <div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">
        <select v-model="iaModelo" style="max-width:190px">
          <option v-for="m in modelos" :key="m" :value="m">{{ m }}</option>
        </select>
        <input v-model="iaChave" type="password" autocomplete="new-password"
               :placeholder="iaTemChave ? `Chave salva (${iaDica}) — digite para trocar` : 'Chave da OpenAI (sk-…)'"
               style="flex:1;min-width:240px" />
        <button type="button" class="text-xs px-3 py-1 rounded"
                style="background:#00a884;color:#fff" :disabled="iaSalvando"
                @click="salvarIa">{{ iaSalvando ? 'Salvando…' : 'Salvar IA' }}</button>
      </div>
      <p class="mt-2 text-xs text-slate-500">
        A chave é gravada fora da configuração da caixa e <b>nunca volta para a
        tela</b> — por isso só aparece o final dela.
      </p>
    </div>

    <p class="text-xs text-slate-500 mb-2">
      Arraste os blocos · ligue arrastando a bolinha de baixo · Esc sai da tela cheia
    </p>

    <!-- Botão de sair da tela cheia: vermelho com X branco, no topo. -->
    <!-- m8: escondido enquanto o modal de importar está aberto — senão este X
         (z-index 9999) flutua POR CIMA do modal (que fica abaixo dele) e o
         operador clica achando que vai fechar o modal e sai da tela cheia. -->
    <button v-if="full && !importAberto" type="button" class="fclose" title="Fechar tela cheia (Esc)" @click="toggleFull">
      ✕
    </button>

    <div
      ref="canvas"
      class="fcanvas rounded-lg"
      :class="{ 'is-full': full }"
      @pointerdown="onCanvasDown"
      @wheel="onWheel"
    >
      <!-- Barra flutuante: fica DENTRO do canvas para continuar acessível em
           tela cheia (antes ela vivia acima e sumia ao ampliar). -->
      <div class="ftoolbar" @pointerdown.stop>
        <!-- Fileira 1: os blocos que se arrasta para o canvas. Some no modo
             consulta (Controle de Acesso): sem edição, não há o que adicionar. -->
        <div v-if="!soLeitura" class="ftrow is-palette">
          <button
            v-for="t in types" :key="t.type" type="button"
            class="ftool is-block" :title="t.hint" @click="addNode(t.type)"
          ><span class="ftool-ico">{{ t.icon }}</span>{{ t.label }}</button>
        </div>

        <!-- Fileira 2: controles, agrupados por função e com cor própria para
             não sumirem no fundo escuro. -->
        <div class="ftrow is-ctl">
          <div class="fgrp">
            <button class="ftool is-icon" type="button" title="Afastar" @click="zoomBy(0.85)">−</button>
            <span class="fzoom-val">{{ Math.round(zoom * 100) }}%</span>
            <button class="ftool is-icon" type="button" title="Aproximar" @click="zoomBy(1.18)">+</button>
            <button class="ftool" type="button" title="Enquadrar o roteiro" @click="fitView">Ajustar</button>
            <!-- Reposiciona os blocos = mutação do roteiro: some na consulta
                 (o método tem guard próprio como rede de segurança). -->
            <button v-if="!soLeitura" class="ftool" type="button"
                    title="Separa os blocos na ordem da conversa" @click="organizar">
              ⌗ Organizar
            </button>
          </div>

          <div class="fgrp">
            <button class="ftool is-test" type="button" @click="startSim">▶ Testar</button>
            <button class="ftool is-view" type="button" @click="toggleFull">
              {{ full ? '⤡ Reduzir' : '⛶ Ampliar' }}
            </button>
            <!-- E1: continua acessível em tela cheia (a toolbar fica dentro do
                 .fcanvas, que sobe junto por cima de tudo). Embutido, dispara o
                 mesmo salvamento do botão "Salvar configuração" do pai. -->
            <button v-if="!soLeitura" class="ftool is-save-flow" type="button" title="Salvar o roteiro"
                    :disabled="embedded ? undefined : (saving || loading)" @click="salvarClique">
              💾 Salvar roteiro
            </button>
          </div>

          <!-- Modelos: salvar o roteiro da tela e reusar em outra caixa. Usar
               um modelo SUBSTITUI o roteiro, então o grupo inteiro some na
               consulta (além disso o save/delete de modelo é admin-only). -->
          <div v-if="!soLeitura" class="fgrp is-tpl">
            <span class="fgrp-tag">Modelos</span>
            <select v-model="tplSel" class="ftool-sel" title="Modelos salvos">
              <option value="">— escolher —</option>
              <option v-for="t in templates" :key="t.id" :value="t.id">
                {{ t.nome }}{{ t.padrao ? ' ★ padrão' : '' }}
              </option>
            </select>
            <button class="ftool is-use" type="button" title="Carregar o modelo escolhido"
                    :disabled="!tplSel" @click="usarTemplate">Usar</button>
            <button class="ftool is-icon is-del" type="button" title="Excluir o modelo escolhido"
                    :disabled="!tplSel" @click="excluirTemplate">🗑</button>
            <button class="ftool is-save" type="button" title="Salvar este roteiro como modelo"
                    @click="salvarTemplate">💾 Salvar template</button>
            <!-- Modelo PADRÃO: vale para a instalação inteira (toda caixa nova
                 nasce com ele), então só o super admin (id 1) marca — o
                 servidor repete o gate em gerenciar_modelos_de_roteiro!. -->
            <template v-if="ehSuperAdmin">
              <button class="ftool is-padrao" type="button"
                      title="Marcar o modelo escolhido como padrão das caixas novas"
                      :disabled="!tplSel" @click="definirPadrao">⭐ Definir como padrão</button>
              <span class="fgrp-dica">
                O modelo padrão já vem montado (desligado) nas caixas novas.
                <template v-if="modeloPadrao">Hoje: <b>{{ modeloPadrao.nome }}</b>.</template>
                <template v-else>Nenhum marcado.</template>
              </span>
            </template>
          </div>

          <!-- Arquivo: leva o roteiro para OUTRA conta/servidor (o modelo só
               vale dentro desta instalação) — inclusive código Python
               executável (nó "script"), então fica reservado ao super admin
               (id 1). Mudança de escopo (decisão do dono, 2026-08-13): a
               regra antiga ("exportar é leitura, todo mundo vê") foi
               substituída por esta. O grupo inteiro nem renderiza para quem
               não é id 1 — e as funções repetem o gate por dentro, caso
               alguém chame pelo DevTools. O que salva de verdade continua
               sendo "Salvar roteiro" depois, pelo gate do servidor. -->
          <div v-if="ehSuperAdmin" class="fgrp is-io">
            <span class="fgrp-tag">Arquivo</span>
            <button class="ftool is-io-exp" type="button"
                    title="Baixar este roteiro como arquivo .json"
                    :disabled="!nodes.length" @click="exportarFluxo">📤 Exportar</button>
            <button class="ftool is-io-exp" type="button"
                    title="Copiar o JSON deste roteiro para a área de transferência"
                    :disabled="!nodes.length" @click="copiarJson">
              {{ copiado ? '✓ Copiado' : '⧉ Copiar JSON' }}
            </button>
            <button v-if="!soLeitura" class="ftool is-use" type="button"
                    title="Carregar um roteiro de arquivo .json ou colando o JSON"
                    @click="abrirImportar">📥 Importar</button>
          </div>
        </div>

        <!-- Escondido: quem abre é o botão do modal de importação. -->
        <input ref="arquivoImport" type="file" accept="application/json,.json"
               style="display:none" @change="onArquivoImport" />
      </div>

      <div :style="{transform:`translate(${pan.x}px,${pan.y}px) scale(${zoom})`,transformOrigin:'0 0',position:'absolute',inset:0}">
        <svg style="position:absolute;overflow:visible;width:1px;height:1px">
          <g v-for="e in edges" :key="e.key" class="fedge-g">
            <!-- trilho grosso e invisível: dá área de mouse na curva fina -->
            <path :d="e.d" class="fedge-hit" fill="none" stroke-width="16" />
            <path :d="e.d" class="fedge" fill="none" stroke-width="2" />
            <g v-if="!soLeitura" class="fedge-del" :transform="`translate(${e.mid.x},${e.mid.y})`"
               @pointerdown.stop.prevent="removeEdge(e)">
              <title>Desfazer esta ligação</title>
              <circle r="10" />
              <path d="M -3.2 -3.2 L 3.2 3.2 M 3.2 -3.2 L -3.2 3.2" />
            </g>
          </g>
          <path v-if="linking" :d="linkPath()" fill="none" stroke="#00a884"
                stroke-width="2.5" stroke-dasharray="5 4" style="pointer-events:none" />
        </svg>

        <div
          v-for="n in nodes" :key="n.id"
          class="fnode" :data-id="n.id"
          :ref="el => registerNodeEl(n.id, el)"
          :style="{position:'absolute',left:n.x+'px',top:n.y+'px',width:'210px',minHeight:'92px'}"
          @pointerdown="onNodeDown($event, n)"
        >
          <div class="fcard" :class="{ 'is-selected': selectedId === n.id }">
            <div class="fcard-head">
              <span>{{ iconOf(n) }} {{ (types.find(t=>t.type===n.type)||{}).label }}</span>
              <span v-if="start===n.id" class="fcard-start">início</span>
            </div>
            <div class="fcard-text">{{ (n.text || '—').slice(0, 70) }}</div>
            <div v-if="n.type==='buttons' || n.type==='list'" class="fcard-chips">
              <span v-for="(o,i) in n.options" :key="i" class="fchip">{{ o.url ? '🔗 ' : '' }}{{ o.label }}</span>
            </div>
            <div v-if="n.type==='carousel'" class="fcard-chips">
              <span v-for="(c,i) in n.cards" :key="i" class="fchip">{{ c.title || ('card ' + (i+1)) }}</span>
            </div>
            <div v-if="n.type==='input'" class="fcard-meta">
              valida: {{ n.validate }} → {{ n.field }}
            </div>
            <div v-if="n.type==='ai'" class="fcard-meta">
              🤖 {{ (agentesIa.find(a => a.id === n.agent) || {}).nome || 'IA padrão' }}
            </div>
            <div v-if="n.type==='link'" class="fcard-meta">🔗 {{ n.label || 'Abrir' }}</div>
            <div v-if="n.type==='delay'" class="fcard-meta">⏳ {{ n.seconds || 2 }}s</div>
            <div v-if="n.type==='oferta'" class="fcard-meta">
              💰 {{ (n.bancos || []).length ? n.bancos.join(', ') : 'todos os bancos' }} · até {{ n.teto_s || 25 }}s
            </div>
            <div v-if="n.type==='ofertas'" class="fcard-meta">
              🏷️ cards das ofertas encontradas
              <template v-if="n.auto_digitar">
                · 📝 auto-digitar
                <span v-if="camposFormFieldsSemColeta(n).length" style="color:#f15c6d">
                  · ⚠️ {{ camposFormFieldsSemColeta(n).length }} campo(s) sem coleta
                </span>
              </template>
            </div>
            <div v-if="n.type==='digitar'" class="fcard-meta">
              📝 {{ n.banco || 'oferta escolhida' }} · {{ Object.keys(n.form_fields || {}).length }} campo(s) mapeado(s)
              <span v-if="camposFormFieldsSemColeta(n).length" style="color:#f15c6d">
                · ⚠️ {{ camposFormFieldsSemColeta(n).length }} campo(s) sem coleta
              </span>
            </div>
            <div v-if="n.type==='trocar_fluxo'" class="fcard-meta">
              {{ (templates.find(t => t.id === n.flow_id) || {}).nome || 'sem modelo' }}
              <template v-if="n.inicio"> · em {{ n.inicio }}</template>
            </div>
            <div v-if="n.type==='bot'" class="fcard-meta">
              🤖 IA {{ n.bot_id || 'padrão' }} · “{{ (n.gatilho || 'gatilho padrão').slice(0, 28) }}”
            </div>
          </div>
          <!-- saídas -->
          <div
            v-for="(p,i) in portsOf(n)" :key="i"
            class="fport" :class="{ 'is-linked': !!p.next }"
            :style="{left:(210/(portsOf(n).length+1)*(i+1)-6)+'px', top:(nodeHeight(n)-6)+'px'}"
            :title="p.label ? ('saída: '+p.label) : 'saída'"
            @pointerdown="onPortDown($event, n, i)"
          />
        </div>
      </div>
    </div>

    <!-- painel do bloco selecionado -->
    <!-- Consulta (Controle de Acesso): <fieldset disabled> desabilita
         NATIVAMENTE todos os input/select/textarea/button descendentes — é o
         jeito de travar as dezenas de v-model deste painel sem espalhar
         :disabled em cada campo. O `.fpanel` zera a borda/padding padrão do
         fieldset no <style>. -->
    <fieldset v-if="selected" :disabled="soLeitura" class="fpanel mt-4 p-4 rounded-lg" :class="{ 'is-full': full }">
      <div style="display:flex;justify-content:space-between;align-items:center" class="mb-3">
        <span class="text-sm font-semibold">{{ iconOf(selected) }} {{ (types.find(t=>t.type===selected.type)||{}).label }}</span>
        <span style="display:flex;gap:8px">
          <button type="button" class="text-xs" style="color:#00a884" @click="start = selected.id">definir como início</button>
          <button type="button" class="text-xs" style="color:#f15c6d" @click="removeNode(selected.id)">excluir</button>
        </span>
      </div>

      <label class="block text-xs font-medium mb-1">Mensagem</label>
      <textarea v-model="selected.text" rows="2" class="mb-3"
                placeholder="O que a Julia fala neste passo. Use {{cpf}} para inserir o que já foi coletado."></textarea>

      <template v-if="selected.type==='buttons' || selected.type==='list'">
        <label class="block text-xs font-medium mb-1">
          {{ selected.type === 'list' ? 'Itens da lista' : 'Botões' }}
          <span class="text-slate-500">(máx. {{ maxOptions(selected) }})</span>
        </label>
        <div v-for="(o,i) in selected.options" :key="i" class="p-2 mb-2 rounded" style="background:rgba(148,163,184,.08)">
          <div style="display:flex;gap:6px" class="mb-1">
            <input v-model="o.label" type="text"
                   :maxlength="selected.type==='list' ? 24 : 20"
                   :placeholder="selected.type==='list' ? 'Título do item' : 'Texto do botão'" />
            <button type="button" class="text-xs" style="color:#f15c6d"
                    @click="selected.options.splice(i,1)">remover</button>
          </div>
          <input v-if="selected.type==='list'" v-model="o.description" type="text" maxlength="72"
                 placeholder="Descrição (opcional)" class="mb-1" />
          <input v-model="o.value" type="text" maxlength="60"
                 placeholder="Valor interno (opcional) — ex.: OF_12X" />
          <input v-if="selected.type==='buttons'" v-model="o.url" type="text"
                 placeholder="Link (opcional) — https://…" class="mt-1" />
          <p v-if="selected.type==='buttons' && o.url" class="text-xs text-slate-500 mt-1">
            Com link preenchido esta opção vira um <b>botão que abre o link</b> em
            outra aba: ela não avança o roteiro e por isso não tem saída no desenho.
          </p>
        </div>
        <button type="button" class="text-xs mb-2" style="color:#00a884"
                :disabled="selected.options.length >= maxOptions(selected)"
                @click="addOption(selected)">+ adicionar</button>
        <p class="text-xs text-slate-500 mb-3">
          O <b>valor interno</b> é o que fica guardado; o texto é só o que o cliente lê.
          Assim dá para mudar o rótulo sem quebrar as condições do roteiro.
          <template v-if="selected.type==='buttons'">
            Deixe o <b>link</b> vazio para o botão seguir o roteiro; preenchido, ele
            só abre o endereço (serve, por exemplo, para mandar o cliente ao WhatsApp).
          </template>
        </p>
        <template v-if="selected.type==='list'">
          <label class="block text-xs font-medium mb-1">Texto do botão que abre a lista</label>
          <input v-model="selected.button" type="text" maxlength="20" placeholder="Ver opções" class="mb-2" />
        </template>
        <label class="block text-xs font-medium mb-1">Guardar a escolha em (opcional)</label>
        <input v-model="selected.field" type="text" placeholder="ex.: produto" class="mb-2" />
        <label v-if="channel !== 'whatsapp'" style="display:flex;align-items:center;gap:8px;cursor:pointer" class="mb-2">
          <input v-model="selected.allow_text" type="checkbox" style="margin:0" />
          <span class="text-xs">Permitir que o cliente digite em vez de clicar (a pergunta livre vai para a IA)</span>
        </label>
        <p v-else class="text-xs text-slate-500 mb-2">
          No WhatsApp o cliente sempre pode digitar — a pergunta livre vai para a IA.
        </p>
      </template>

      <template v-if="selected.type==='carousel'">
        <p class="text-xs text-slate-500 mb-2">
          De 2 a 10 cards. Todos os cards têm os <b>mesmos botões</b> — é regra do
          WhatsApp e evita cards de alturas diferentes.
        </p>
        <div v-for="(c,ci) in selected.cards" :key="ci" class="p-2 mb-2 rounded" style="background:rgba(148,163,184,.08)">
          <div style="display:flex;gap:6px;align-items:center" class="mb-1">
            <b class="text-xs">Card {{ ci + 1 }}</b>
            <button v-if="selected.cards.length > 2" type="button" class="text-xs" style="color:#f15c6d"
                    @click="selected.cards.splice(ci,1)">remover</button>
          </div>
          <input v-model="c.title" type="text" maxlength="60" placeholder="Título — ex.: R$ 1.847" class="mb-1" />
          <input v-model="c.body" type="text" maxlength="160" placeholder="Descrição — ex.: em 12x de R$ 180" class="mb-1" />
          <input v-model="c.image" type="text" placeholder="URL da imagem (opcional)" class="mb-1" />
          <div v-for="(b,bi) in c.buttons" :key="bi" style="display:flex;gap:6px" class="mb-1">
            <input v-model="b.label" type="text" maxlength="20" placeholder="Botão" />
            <input v-model="b.value" type="text" maxlength="60" placeholder="Valor interno" />
            <input v-model="b.url" type="text" placeholder="URL (deixe vazio p/ seguir o roteiro)" />
          </div>
        </div>
        <div style="display:flex;gap:12px" class="mb-3">
          <button type="button" class="text-xs" style="color:#00a884"
                  :disabled="selected.cards.length >= 10" @click="addCard(selected)">+ card</button>
          <button type="button" class="text-xs" style="color:#00a884"
                  :disabled="!selected.cards.length || selected.cards[0].buttons.length >= 2"
                  @click="addCardButton(selected)">+ botão em todos</button>
          <button v-if="selected.cards.length && selected.cards[0].buttons.length > 1"
                  type="button" class="text-xs" style="color:#f15c6d"
                  @click="removeCardButton(selected, selected.cards[0].buttons.length - 1)">− botão</button>
        </div>
        <label class="block text-xs font-medium mb-1">Guardar a escolha em (opcional)</label>
        <input v-model="selected.field" type="text" placeholder="ex.: oferta" class="mb-2" />
      </template>

      <template v-if="selected.type==='link'">
        <label class="block text-xs font-medium mb-1">Endereço (URL)</label>
        <input v-model="selected.url" type="text" placeholder="https://… (aceita {{variavel}})" class="mb-2" />
        <label class="block text-xs font-medium mb-1">Texto do botão</label>
        <input v-model="selected.label" type="text" maxlength="20" placeholder="Assinar agora" class="mb-2" />
        <p class="text-xs text-slate-500">O link abre em outra aba e o roteiro continua.</p>
      </template>

      <template v-if="selected.type==='image'">
        <label class="block text-xs font-medium mb-1">URL da imagem</label>
        <input v-model="selected.src" type="text" placeholder="https://…" class="mb-2" />
        <p class="text-xs text-slate-500">A mensagem acima vira a legenda.</p>
      </template>

      <template v-if="selected.type==='delay'">
        <label class="block text-xs font-medium mb-1">Segundos de "digitando…"</label>
        <input v-model.number="selected.seconds" type="number" min="0.2" max="10" step="0.5"
               style="max-width:120px" class="mb-2" />
        <p class="text-xs text-slate-500">
          Dá naturalidade depois de uma consulta. Entre 0,2 e 10 segundos.
        </p>
      </template>

      <template v-if="selected.type==='input'">
        <label class="block text-xs font-medium mb-1">O que pedir</label>
        <select v-model="selected.validate" class="mb-2" style="max-width:220px">
          <option value="cpf">CPF (valida na hora)</option>
          <option value="telefone">Telefone</option>
          <option value="email">E-mail</option>
          <option value="numero">Número</option>
          <option value="cep">CEP (8 números)</option>
          <option value="uf">Estado (UF)</option>
          <option value="banco">Banco (código de 3 números)</option>
          <option value="agencia">Agência (até 5 números)</option>
          <option value="conta">Conta (até 12 números)</option>
          <option value="digito">Dígito da conta (1 número ou X)</option>
          <option value="texto">Texto livre</option>
        </select>
        <label class="block text-xs font-medium mb-1">Guardar em</label>
        <input v-model="selected.field" type="text" placeholder="ex.: cpf" class="mb-2" />
        <label class="block text-xs font-medium mb-1">Mensagem quando não validar</label>
        <input v-model="selected.error" type="text" placeholder="Esse CPF não confere. Pode revisar?" class="mb-2" />
      </template>

      <template v-if="selected.type==='condition'">
        <label class="block text-xs font-medium mb-1">Variável</label>
        <input v-model="selected.var" type="text" placeholder="ex.: cpf" class="mb-2" />
        <label class="block text-xs font-medium mb-1">Condição</label>
        <select v-model="selected.op" class="mb-2" style="max-width:220px">
          <option value="preenchido">está preenchida</option>
          <option value="igual">é igual a</option>
          <option value="contem">contém</option>
        </select>
        <input v-if="selected.op!=='preenchido'" v-model="selected.value" type="text" placeholder="valor" class="mb-2" />
        <p class="text-xs text-slate-500">A primeira saída é o "sim", a segunda é o "não".</p>
      </template>

      <template v-if="selected.type==='ai'">
        <label class="block text-xs font-medium mb-1">Qual IA atende a partir daqui</label>
        <select v-model="selected.agent" class="mb-2" style="max-width:280px">
          <option value="">A IA padrão da caixa</option>
          <option v-for="a in agentesIa" :key="a.id" :value="a.id">{{ a.nome || a.id }}</option>
        </select>
        <p v-if="!agentesIa.length" class="text-xs text-slate-500">
          Nenhuma IA criada ainda — crie na aba "As IAs". Sem IA, este bloco
          encerra o roteiro e a conversa fica para um atendente.
        </p>
      </template>

      <template v-if="selected.type==='agent'">
        <label class="block text-xs font-medium mb-1">Etiqueta a aplicar (opcional)</label>
        <input v-model="selected.label" type="text" placeholder="ex.: atendimento_humano" class="mb-2" />
      </template>

      <!-- ============ HTTP (estilo n8n) ============ -->
      <template v-if="selected.type==='http'">
        <div class="fhelp">Chama uma API e salva a resposta em variáveis. Use <code>&#123;&#123;cpf&#125;&#125;</code> nos campos e <code>&#123;&#123;secret:NOME&#125;&#125;</code> para credenciais.</div>
        <div class="flex gap-2 mb-2">
          <select v-model="selected.metodo" style="max-width:110px">
            <option>GET</option><option>POST</option><option>PUT</option><option>PATCH</option><option>DELETE</option>
          </select>
          <input v-model="selected.url" type="text" placeholder="https://api.exemplo.com/consulta" class="flex-1" />
        </div>
        <label class="block text-xs font-medium mb-1">Headers</label>
        <div v-for="(h,i) in selected.headers" :key="'h'+i" class="flex gap-2 mb-1">
          <input v-model="h.chave" type="text" placeholder="Authorization" class="flex-1" />
          <input v-model="h.valor" type="text" placeholder="Bearer &#123;&#123;secret:token&#125;&#125;" class="flex-1" />
          <button type="button" class="fx" @click="selected.headers.splice(i,1)">✕</button>
        </div>
        <button type="button" class="fadd mb-2" @click="selected.headers.push({chave:'',valor:''})">＋ header</button>

        <label class="block text-xs font-medium mb-1">Query (?a=b)</label>
        <div v-for="(q,i) in selected.query" :key="'q'+i" class="flex gap-2 mb-1">
          <input v-model="q.chave" type="text" placeholder="cpf" class="flex-1" />
          <input v-model="q.valor" type="text" placeholder="&#123;&#123;cpf&#125;&#125;" class="flex-1" />
          <button type="button" class="fx" @click="selected.query.splice(i,1)">✕</button>
        </div>
        <button type="button" class="fadd mb-2" @click="selected.query.push({chave:'',valor:''})">＋ query</button>

        <label class="block text-xs font-medium mb-1">Corpo</label>
        <select v-model="selected.body_modo" class="mb-1" style="max-width:160px">
          <option value="none">Sem corpo</option><option value="json">JSON</option><option value="raw">Texto</option>
        </select>
        <textarea v-if="selected.body_modo!=='none'" v-model="selected.body" rows="4"
          placeholder='{"cpf":"{{cpf}}"}' class="mb-2 font-mono" />

        <label class="block text-xs font-medium mb-1">Salvar campos da resposta em variáveis</label>
        <div v-for="(m,i) in selected.mapear" :key="'m'+i" class="flex gap-2 mb-1">
          <input v-model="m.campo" type="text" placeholder="campo do JSON" class="flex-1" />
          <span class="text-xs self-center">→</span>
          <input v-model="m.var" type="text" placeholder="variável" class="flex-1" />
          <button type="button" class="fx" @click="selected.mapear.splice(i,1)">✕</button>
        </div>
        <button type="button" class="fadd mb-2" @click="selected.mapear.push({campo:'',var:''})">＋ campo</button>

        <div class="flex gap-2 items-center mb-2">
          <label class="text-xs">Timeout (s)</label>
          <input v-model.number="selected.timeout_seg" type="number" min="3" max="30" style="max-width:80px" />
          <label class="text-xs ml-2">Guardar tudo em</label>
          <input v-model="selected.salvar_em" type="text" placeholder="resposta" class="flex-1" />
        </div>
        <button type="button" class="ftest" :disabled="acaoTestando" @click="testarAcao(selected)">
          {{ acaoTestando ? 'Testando…' : '▶ Testar requisição' }}
        </button>
        <pre v-if="acaoResultado" class="fresult">{{ acaoResultado }}</pre>
      </template>

      <!-- ============ Supabase ============ -->
      <template v-if="selected.type==='supabase'">
        <div class="fhelp">Salva ou consulta o atendimento no banco. Só tabelas liberadas nesta caixa aparecem.</div>
        <div class="flex gap-2 mb-2">
          <select v-model="selected.op" style="max-width:130px">
            <option value="inserir">Inserir</option><option value="consultar">Consultar</option>
          </select>
          <select v-model="selected.tabela" class="flex-1">
            <option value="">— escolha a tabela —</option>
            <option v-for="t in sbTabelas" :key="t" :value="t">{{ t }}</option>
          </select>
          <button type="button" class="fadd" :disabled="sbCarregando" @click="carregarTabelas(selected.tabela)">
            {{ sbCarregando ? '…' : '↻' }}
          </button>
        </div>
        <p v-if="!sbTabelas.length" class="fhelp">Nenhuma tabela liberada. Libere na aba (Segredos & Supabase) e clique ↻.</p>

        <label class="block text-xs font-medium mb-1">
          {{ selected.op==='inserir' ? 'Colunas a gravar (o valor aceita variáveis)' : 'Filtros (coluna = valor)' }}
        </label>
        <textarea :value="kvText(selected.op==='inserir' ? selected.valores : selected.filtros)"
          rows="4" class="mb-1 font-mono" placeholder="coluna=valor por linha"
          @input="setKv(selected, selected.op==='inserir' ? 'valores' : 'filtros', $event.target.value)" />
        <p v-if="sbColunas.length" class="fhelp">Colunas: {{ sbColunas.join(', ') }}</p>

        <div class="flex gap-2 items-center mb-2">
          <template v-if="selected.op==='consultar'">
            <label class="text-xs">Limite</label>
            <input v-model.number="selected.limit" type="number" min="1" max="100" style="max-width:80px" />
          </template>
          <label class="text-xs ml-1">Salvar resultado em</label>
          <input v-model="selected.salvar_em" type="text" placeholder="consulta" class="flex-1" />
        </div>
        <button type="button" class="ftest" :disabled="acaoTestando || !selected.tabela" @click="testarAcao(selected)">
          {{ acaoTestando ? 'Testando…' : '▶ Testar no banco' }}
        </button>
        <pre v-if="acaoResultado" class="fresult">{{ acaoResultado }}</pre>
      </template>

      <!-- ============ Destaque (splash) ============ -->
      <template v-if="selected.type==='splash'">
        <div class="fhelp">
          Estoura na tela do cliente por cima da conversa. Aceita <b>imagem</b>,
          <b>vídeo</b> (link .mp4) ou <b>YouTube</b>. Só vale no webchat — no
          WhatsApp este bloco é ignorado.
        </div>
        <label class="block text-xs font-medium mb-1">Título</label>
        <input v-model="selected.titulo" type="text" maxlength="80"
               placeholder="Novidade!" class="mb-2" />
        <label class="block text-xs font-medium mb-1">
          Imagem, vídeo ou link do YouTube (opcional)
        </label>
        <input v-model="selected.midia" type="text"
               placeholder="https://… .jpg / .mp4 / youtube.com/watch?v=…" class="mb-1" />
        <div v-if="selected.midia" class="fsplash-prev mb-2">
          <img v-if="!ehVideo(selected.midia)" :src="selected.midia" alt="" @error="$event.target.style.display='none'" />
          <p v-else class="fhelp" style="margin:0">▶ vídeo — aparece com player na conversa</p>
        </div>

        <label class="block text-xs font-medium mb-1">Botões (até 3)</label>
        <div v-for="(b,i) in selected.botoes" :key="'sb'+i" class="flex gap-2 mb-1">
          <input v-model="b.label" type="text" maxlength="24" placeholder="IR PARA O SITE" style="max-width:150px" />
          <input v-model="b.url" type="text" placeholder="https://… (vazio = só fecha)" class="flex-1" />
          <button type="button" class="fx" @click="selected.botoes.splice(i,1)">✕</button>
        </div>
        <button v-if="selected.botoes.length < 3" type="button" class="fadd mb-2"
                @click="selected.botoes.push({label:'',url:''})">＋ botão</button>
        <p class="fhelp">
          Botão sem link fecha o destaque (ex.: “OK”). Com link, abre em outra aba
          — serve para site, Instagram, WhatsApp, o que você quiser.
        </p>
      </template>

      <!-- ============ Script Python (isolado) ============ -->
      <template v-if="selected.type==='script'">
        <div class="fhelp">Roda Python <b>isolado</b>: sem internet e sem os segredos do sistema. Use <code>vars</code> (dicionário do fluxo); o que você puser em <code>vars</code> volta pro roteiro. Para API/banco use os blocos HTTP/Supabase.</div>
        <label class="block text-xs font-medium mb-1">Código Python</label>
        <textarea v-model="selected.code" rows="8" class="mb-2 font-mono" spellcheck="false" />
        <label class="block text-xs font-medium mb-1">Variáveis do cabeçalho (.env) — chave=valor por linha</label>
        <textarea :value="kvText(selected.env)" rows="3" class="mb-1 font-mono"
          placeholder="TAXA=1.8&#10;ORIGEM=&#123;&#123;produto&#125;&#125;"
          @input="setKv(selected, 'env', $event.target.value)" />
        <div class="flex gap-2 items-center mb-2">
          <label class="text-xs">Salvar saída em</label>
          <input v-model="selected.salvar_em" type="text" placeholder="saida" class="flex-1" />
        </div>
        <button type="button" class="ftest" :disabled="acaoTestando" @click="testarAcao(selected)">
          {{ acaoTestando ? 'Testando…' : '▶ Testar script' }}
        </button>
        <pre v-if="acaoResultado" class="fresult">{{ acaoResultado }}</pre>
      </template>

      <!-- ============ Consultar oferta (bancos de verdade) ============ -->
      <template v-if="selected.type==='oferta'">
        <div class="fhelp">
          Consulta a oferta nos <b>bancos de verdade</b> com o CPF que o roteiro já
          coletou e <b>guarda o resultado</b> numa variável. Não mostra nada para o
          cliente: quem mostra é o bloco <b>Mostrar ofertas</b>, logo depois.
          A saída <b>“achou oferta”</b> segue quando algum banco respondeu com
          proposta; a saída <b>“não achou”</b> segue quando ninguém tinha nada.
        </div>
        <label class="block text-xs font-medium mb-1">Bancos a consultar (só os ATIVOS nesta caixa)</label>
        <div v-if="bancosDisponiveis.length" class="fbancos mb-1">
          <label v-for="b in bancosDisponiveis" :key="b.id" class="fbanco">
            <input type="checkbox" :value="b.id" v-model="selected.bancos" />
            <span>{{ b.nome }}</span>
          </label>
        </div>
        <p v-else class="text-xs mb-1" style="color:#d97706">
          Esta caixa ainda não tem nenhum banco com credencial ativa — configure
          em <b>Credenciais dos Bancos</b> para eles aparecerem aqui.
        </p>
        <p class="text-xs text-slate-500 mb-3">
          Nenhum marcado = consulta <b>todos</b> os bancos ativos nesta caixa.
          Quanto mais bancos, mais demora a resposta.
        </p>

        <template v-if="(selected.bancos || []).length > 1">
          <label class="block text-xs font-medium mb-1">
            Prioridade (1º = preferido; empate no ranking = maior valor liberado)
          </label>
          <ol class="fprioridade mb-3">
            <li v-for="(bid, i) in selected.bancos" :key="bid" class="fprioridade-item">
              <span class="fprioridade-num">{{ i + 1 }}º</span>
              <span class="flex-1">{{ nomeBanco(bid) }}</span>
              <button type="button" class="fprioridade-btn" :disabled="i === 0"
                title="Subir prioridade" @click="moverBanco(selected, i, -1)">▲</button>
              <button type="button" class="fprioridade-btn" :disabled="i === selected.bancos.length - 1"
                title="Descer prioridade" @click="moverBanco(selected, i, 1)">▼</button>
            </li>
          </ol>
        </template>

        <div class="flex gap-2 items-center mb-1">
          <label class="text-xs">Esperar no máximo (segundos)</label>
          <input v-model.number="selected.teto_s" type="number" min="5" max="70" style="max-width:90px" />
        </div>
        <p class="text-xs text-slate-500 mb-3">
          Passou desse tempo, o roteiro segue com o que já chegou (de 5 a 60s; o
          normal é 25).
        </p>

        <label class="block text-xs font-medium mb-1">Guardar as ofertas em</label>
        <input v-model="selected.salvar_em" type="text" placeholder="ofertas" class="mb-1" />
        <p class="text-xs text-slate-500 mb-2">
          É o nome da variável que o bloco <b>Mostrar ofertas</b> lê. Só letras,
          números e “_”.
        </p>
      </template>

      <!-- ============ Transferir BOT (passa a conversa para outro MODELO) ============ -->
      <template v-if="selected.type==='trocar_fluxo'">
        <div class="fhelp">
          <b>Passa a conversa para outro roteiro</b> — um dos <b>modelos salvos</b>.
          Daqui em diante quem conduz é o modelo escolhido, e o que já foi
          coletado (CPF, nome, telefone…) <b>continua valendo</b>: por isso a
          transferência não precisa começar do zero.
        </div>

        <label class="block text-xs font-medium mb-1">Modelo que assume a conversa</label>
        <select v-model="selected.flow_id" class="mb-1">
          <option value="">— escolher modelo —</option>
          <option v-for="t in templates" :key="t.id" :value="t.id">
            {{ t.nome }} ({{ t.blocos }} blocos)
          </option>
        </select>
        <p class="text-xs text-slate-500 mb-3">
          São os mesmos modelos da barra <b>MODELOS</b>, no topo. Sem modelo
          escolhido o bloco não faz nada e o roteiro segue pela saída normal.
        </p>

        <label class="block text-xs font-medium mb-1">Começar em (opcional)</label>
        <input v-model="selected.inicio" type="text" placeholder="deixe vazio: pula a 1ª mensagem" class="mb-1" />
        <p class="text-xs text-slate-500 mb-2">
          <b>Vazio</b> (recomendado): pula <b>apenas a primeira mensagem</b> do
          modelo — a saudação, que o cliente já ouviu — e cai no passo seguinte,
          normalmente o <b>pedido de CPF</b>. Para entrar em outro ponto, escreva
          aqui o <b>id do bloco</b> do modelo (ex.: <code>n3</code>).
        </p>
        <p class="text-xs text-slate-500 mb-2">
          Se o cliente já informou o CPF e você não quer perguntar de novo, ponha
          um bloco <b>Condição</b> no modelo, no campo <code>cpf</code>, com a
          operação <b>preenchido</b>.
        </p>
      </template>

      <!-- ============ Transferir para IA (agent bot do Chatwoot) ============ -->
      <template v-if="selected.type==='bot'">
        <div class="fhelp">
          <b>Entrega a conversa</b> para uma IA que já atende no WhatsApp (ex.: a
          FGTS IA). O webchat faz as duas coisas que a transferência exige:
          <b>atribui a IA à conversa</b> — é o que faz as próximas mensagens do
          cliente chegarem nela — e <b>manda o gatilho</b> para ela começar agora.
          Diferente do bloco <b>Passar para IA</b>, que é a IA desta própria caixa.
        </div>

        <label class="block text-xs font-medium mb-1">Qual IA (número do agent bot)</label>
        <input v-model.number="selected.bot_id" type="number" min="1" max="999"
          placeholder="1" class="mb-1" style="max-width:120px" />
        <p class="text-xs text-slate-500 mb-3">
          É o número do <b>Agent Bot</b> no Chatwoot (a FGTS IA é a <b>1</b>).
          Em branco = a IA padrão configurada no servidor.
        </p>

        <label class="block text-xs font-medium mb-1">Webhook da IA</label>
        <input v-model="selected.url" type="text"
          placeholder="https://atendimento-ia.mazam.ai/fgts-ia/webhook/chatwoot" class="mb-1" />
        <p class="text-xs text-slate-500 mb-3">
          O mesmo endereço do campo <b>Outgoing URL</b> do bot no Chatwoot. Em
          branco = o padrão do servidor.
        </p>

        <label class="block text-xs font-medium mb-1">Gatilho (o que a IA recebe como se o cliente tivesse dito)</label>
        <input v-model="selected.gatilho" type="text"
          placeholder="Quero antecipar meu FGTS" class="mb-1" maxlength="300" />
        <p class="text-xs text-slate-500 mb-3">
          Frase natural que faz a IA começar já no assunto, em vez de saudar de
          novo. Aceita variáveis: <code>&#123;&#123;cpf&#125;&#125;</code>,
          <code>&#123;&#123;nome&#125;&#125;</code>…
        </p>

        <p class="text-xs text-slate-500 mb-2">
          O campo <b>Mensagem</b> lá em cima é opcional e é falado ao cliente
          <b>antes</b> da transferência (ex.: “vou te passar para a nossa
          especialista”): ela leva alguns segundos e, sem aviso, parece travada.
          Em branco = não fala nada.
        </p>

        <p class="text-xs text-slate-500 mb-2">
          Deu errado? O atendimento <b>não cai</b>: fica registrado em nota
          interna e o roteiro segue pela saída deste bloco. Para tratar a falha,
          ponha em seguida um bloco <b>Condição</b> na variável
          <code>bot_transferido</code>.
        </p>
      </template>

      <!-- ============ Mostrar ofertas ============ -->
      <template v-if="selected.type==='ofertas'">
        <div class="fhelp">
          Mostra os <b>cards das ofertas</b> que a consulta anterior encontrou e
          <b>espera o cliente escolher</b> uma. Depois que ele escolhe, o roteiro
          segue pela única saída deste bloco. Use o campo <b>Mensagem</b> lá em
          cima para o texto que aparece junto dos cards.
        </div>
        <p class="text-xs text-slate-500 mb-2">
          Ponha este bloco na saída <b>“achou oferta”</b> do bloco
          <b>Consultar oferta</b> — sem consulta antes, não há o que mostrar.
        </p>

        <label style="display:flex;align-items:center;gap:8px;cursor:pointer" class="mb-2">
          <input v-model="selected.auto_digitar" type="checkbox" style="margin:0" />
          <span class="text-xs font-medium">
            Digitar automaticamente ao escolher (sem precisar do nó
            <b>Digitar proposta</b> separado)
          </span>
        </label>

        <template v-if="selected.auto_digitar">
          <p class="text-xs text-slate-500 mb-3">
            <b>Importante:</b> antes deste bloco o roteiro precisa ter
            <b>coletado</b> (com blocos <b>Pedir dado</b>) tudo que falta na
            ficha — data de nascimento, nome da mãe, endereço completo (CEP,
            rua, número, bairro, cidade, UF) e a forma de recebimento (chave
            PIX ou dados da conta). Sem isso a digitação falha e o cliente cai
            num aviso amigável — o roteiro <b>não trava</b>. Nome, CPF, e-mail
            e telefone já vêm automáticos do que o cliente já informou.
          </p>

          <label class="block text-xs font-medium mb-1">
            Mapear campos do formulário (campo do banco = variável do fluxo)
          </label>
          <textarea :value="kvText(selected.form_fields)" rows="9" class="mb-1 font-mono"
            placeholder="nascimento=nascimento&#10;nome_mae=nome_mae&#10;endereco.cep=endereco_cep&#10;recebimento.pix_chave=recebimento_pix_chave"
            @input="setKv(selected, 'form_fields', $event.target.value)" />
          <p class="text-xs text-slate-500 mb-2">
            Mesmo formato do bloco <b>Digitar proposta</b>: um
            <code>campo=variável</code> por linha; <code>endereco.*</code> e
            <code>recebimento.*</code> são grupos (a mesma variável que o
            bloco <b>Pedir dado</b> usou para guardar a resposta). Linha em
            branco/sem “=” é ignorada.
          </p>
        </template>
      </template>

      <!-- ============ Digitar proposta (envia ao banco de verdade) ============ -->
      <template v-if="selected.type==='digitar'">
        <div class="fhelp">
          Envia ao banco a <b>proposta que o cliente escolheu</b> (bloco
          <b>Mostrar ofertas</b>, antes deste) para <b>digitação de verdade</b>.
          Reusa a mesma consulta do bloco <b>Consultar oferta</b> — não simula
          de novo. O retorno vem nas variáveis <code>digitacao_status</code>
          (<code>ok</code>/<code>erro</code>), <code>digitacao_codigo</code>,
          <code>digitacao_link</code>, <code>digitacao_mensagem</code> e
          <code>digitacao_proposta_id</code>: ponha um bloco <b>Condição</b>
          na saída deste para tratar os dois casos.
        </div>
        <p class="text-xs text-slate-500 mb-3">
          <b>Importante:</b> antes deste bloco o roteiro precisa ter
          <b>coletado</b> (com blocos <b>Pedir dado</b>) tudo que falta na
          ficha — data de nascimento, nome da mãe, endereço completo (CEP,
          rua, número, bairro, cidade, UF) e a forma de recebimento (chave
          PIX ou dados da conta). Sem isso o banco recusa a proposta. Nome,
          CPF, e-mail e telefone já vêm automáticos do que o cliente já
          informou.
        </p>

        <label class="block text-xs font-medium mb-1">
          Banco (opcional — em branco usa a oferta que o cliente escolheu)
        </label>
        <input v-model="selected.banco" type="text" list="fdigitar-bancos"
               placeholder="em branco = escolha do cliente" class="mb-1" />
        <datalist id="fdigitar-bancos">
          <option v-for="b in bancosDisponiveis" :key="b.id" :value="b.id">{{ b.nome }}</option>
        </datalist>

        <div class="flex gap-2 items-center mb-3">
          <label class="text-xs">Índice da oferta (opcional)</label>
          <input v-model="selected.indice" type="number" min="0"
                 placeholder="em branco = escolha do cliente" style="max-width:170px" />
        </div>

        <label class="block text-xs font-medium mb-1">
          Mapear campos do formulário (campo do banco = variável do fluxo)
        </label>
        <textarea :value="kvText(selected.form_fields)" rows="9" class="mb-1 font-mono"
          placeholder="nascimento=nascimento&#10;nome_mae=nome_mae&#10;endereco.cep=endereco_cep&#10;recebimento.pix_chave=recebimento_pix_chave"
          @input="setKv(selected, 'form_fields', $event.target.value)" />
        <p class="text-xs text-slate-500 mb-2">
          Um <code>campo=variável</code> por linha. <code>endereco.*</code> e
          <code>recebimento.*</code> são grupos (1 nível de aninhamento): use
          o nome do CAMPO DO BANCO à esquerda — endereço
          (<code>endereco.cep</code>, <code>logradouro</code>,
          <code>numero</code>, <code>bairro</code>, <code>cidade</code>,
          <code>uf</code>) e recebimento
          (<code>recebimento.pix_tipo</code>, <code>pix_chave</code> OU
          <code>banco_codigo</code>, <code>agencia</code>, <code>conta</code>,
          <code>conta_digito</code>, <code>tipo_conta</code>) — e o nome da
          <b>variável do fluxo</b> à direita, a mesma que o bloco
          <b>Pedir dado</b> usou para guardar aquela resposta. Linha em
          branco/sem “=” é ignorada.
        </p>
      </template>
    </fieldset>
    <p v-else class="text-xs text-slate-500 mt-3">Clique num bloco para editar o conteúdo dele.</p>

    <!-- problemas -->
    <div v-if="problems.length" class="mt-4 p-3 rounded-lg" style="background:rgba(241,92,109,.10)">
      <p class="text-xs font-semibold mb-1" style="color:#f15c6d">Revise antes de ativar:</p>
      <ul class="text-xs" style="list-style:disc;padding-left:18px">
        <li v-for="(p,i) in problems" :key="i">{{ p }}</li>
      </ul>
    </div>

    <!-- C1: o que o roteiro importado EXECUTA/CHAMA (código do nó "script",
         host do "http", destino do "bot") — vem SEMPRE ANTES dos demais
         avisos e com destaque próprio (vermelho, não âmbar): não é "revisar
         quando puder", é "isto roda código/chama rede quando tocar aqui". -->
    <div v-if="avisoCritico.length" class="mt-4 p-3 rounded-lg"
         style="background:rgba(241,92,109,.12);border:1px solid rgba(241,92,109,.35)">
      <div style="display:flex;align-items:flex-start;gap:8px">
        <p class="text-xs font-semibold mb-1" style="color:#f15c6d;flex:1">
          🔒 Segurança — confira antes de tudo
        </p>
        <button type="button" class="text-xs" style="color:#f15c6d;font-weight:700"
                title="Fechar aviso" @click="avisoCritico = []">✕</button>
      </div>
      <ul class="text-xs" style="list-style:disc;padding-left:18px">
        <li v-for="(a,i) in avisoCritico" :key="i">{{ a }}</li>
      </ul>
    </div>

    <!-- Avisos do último exportar/importar: o que foi limpo por segurança e o
         que depende de configuração desta caixa. Some no primeiro ✕. -->
    <div v-if="avisos.length" class="mt-4 p-3 rounded-lg" style="background:rgba(217,119,6,.12)">
      <div style="display:flex;align-items:flex-start;gap:8px">
        <p class="text-xs font-semibold mb-1" style="color:#b45309;flex:1">
          ⚠️ {{ avisosTitulo }}
        </p>
        <button type="button" class="text-xs" style="color:#b45309;font-weight:700"
                title="Fechar avisos" @click="avisos = []">✕</button>
      </div>
      <ul class="text-xs" style="list-style:disc;padding-left:18px">
        <li v-for="(a,i) in avisos" :key="i">{{ a }}</li>
      </ul>
    </div>

    <!-- Importar roteiro: arquivo .json OU JSON colado. Só carrega no canvas —
         nada vai para o servidor até o operador clicar em Salvar roteiro. -->
    <div v-if="importAberto" class="fio-backdrop" @click.self="importAberto = false">
      <div class="fio-modal">
        <p class="text-sm font-semibold mb-1">📥 Importar roteiro</p>
        <p class="text-xs text-slate-500 mb-3">
          Aceita o arquivo <code>.json</code> gerado pelo botão <b>Exportar</b>
          (desta ou de outra conta). O roteiro é carregado só na tela: nada muda
          nesta caixa até você clicar em <b>Salvar roteiro</b>.
        </p>

        <button type="button" class="ftool is-use mb-3" @click="escolherArquivo">
          📂 Escolher arquivo .json
        </button>

        <label class="block text-xs font-medium mb-1">…ou cole o JSON aqui</label>
        <textarea v-model="importTexto" rows="9" class="font-mono"
                  placeholder='{ "mazam_flow": 1, "flow": { "start": "n1", "nodes": [ … ] } }' />

        <p v-if="importErro" class="mt-2 text-xs p-2 rounded"
           style="background:rgba(241,92,109,.14);color:#b91c1c">{{ importErro }}</p>

        <div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px">
          <button type="button" class="ftool" @click="importAberto = false">Cancelar</button>
          <button type="button" class="ftool is-use" :disabled="!importTexto.trim()"
                  @click="importarColado">Importar do texto</button>
        </div>
      </div>
    </div>

    <!-- C1: nó "script" traz código Python que o servidor EXECUTA de verdade
         (mazam-webchat/_exec_script -> py_runner exec()). Um arquivo .json é
         canal externo, então antes de aplicar no canvas o código fica À
         VISTA para revisão — mesmo para o super admin, é proteção contra um
         arquivo que outra pessoa mandou para ele. -->
    <div v-if="importScriptPendente" class="fio-backdrop" @click.self="cancelarImportComCodigo">
      <div class="fio-modal">
        <p class="text-sm font-semibold mb-1" style="color:#f15c6d">
          🔒 Este arquivo contém código que será executado no servidor
        </p>
        <p class="text-xs text-slate-500 mb-3">
          Revise antes de continuar — o código roda isolado, mas com rede
          alcançável e os dados desta conversa (CPF, telefone…). Importar
          substitui o roteiro que está na tela ({{ nodes.length }} bloco(s)).
        </p>
        <div v-for="(b, i) in importScriptPendente.blocos" :key="i" class="mb-3">
          <p class="text-xs font-semibold mb-1">{{ b.titulo }}</p>
          <pre style="max-height:180px;overflow:auto;font-size:11px;padding:8px;border-radius:8px;background:rgba(148,163,184,.14);white-space:pre-wrap;word-break:break-word">{{ b.code.length > 4000 ? (b.code.slice(0, 4000) + '\n… (truncado — ' + b.code.length + ' caracteres no total)') : b.code }}</pre>
        </div>
        <div style="display:flex;gap:8px;justify-content:flex-end;margin-top:12px">
          <button type="button" class="ftool" @click="cancelarImportComCodigo">Cancelar</button>
          <button type="button" class="ftool" style="background:#e02c3d;color:#fff;border-color:#e02c3d"
                  @click="confirmarImportComCodigo">Importar mesmo assim</button>
        </div>
      </div>
    </div>

    <!-- Simulador em moldura de celular: testar o roteiro vendo exatamente o que
         o cliente vê. Fica por cima de tudo, inclusive da tela cheia. -->
    <div v-if="sim" class="fsim-backdrop" @click.self="sim = null">
      <div class="fphone">
        <div class="fphone-notch" />
        <div class="fphone-screen">
          <div class="fphone-top">
            <div class="fphone-avatar">{{ (inbox.name || 'M').charAt(0).toUpperCase() }}</div>
            <div>
              <div class="fphone-name">{{ inbox.name || 'Atendimento' }}</div>
              <div class="fphone-status">online</div>
            </div>
          </div>

          <div ref="simScroll" class="fphone-body">
            <div v-for="(l,i) in sim.log" :key="i" class="fmsg-row" :class="'is-'+l.who">
              <div v-if="l.who==='sys'" class="fmsg-sys">{{ l.text }}</div>
              <div v-else class="fmsg" :class="l.who==='cli' ? 'is-out' : 'is-in'">{{ l.text }}</div>
            </div>

            <div v-if="sim.node && ['buttons','list','carousel'].includes(sim.node.type)" class="fsim-btns">
              <button v-for="(o,i) in simChoices(sim.node)" :key="i" type="button" @click="simPick(o)">
                {{ o.echo || o.label }}
              </button>
            </div>
          </div>

          <div class="fphone-composer">
            <template v-if="sim.node && sim.node.type==='input'">
              <input
                ref="simInput" type="text"
                :placeholder="sim.node.validate==='cpf' ? '000.000.000-00' : ('digite o '+(sim.node.field||'dado'))"
                @keydown.enter="simSend($event.target.value); $event.target.value=''"
              />
              <button type="button" class="fsend" @click="simSend($refs.simInput.value); $refs.simInput.value=''">➤</button>
            </template>
            <template v-else>
              <input type="text" :placeholder="sim.done ? 'Roteiro encerrado' : 'Aguardando o roteiro…'" disabled />
              <button type="button" class="fsend is-off" disabled>➤</button>
            </template>
          </div>
        </div>
        <div class="fphone-bar" />
      </div>

      <div class="fsim-actions">
        <button type="button" class="fsim-restart" @click="startSim">↻ Recomeçar</button>
        <button type="button" class="fsim-close" title="Fechar (Esc)" @click="sim = null">✕</button>
      </div>
    </div>

    <div v-if="!embedded && !soLeitura" class="mt-5">
      <button type="button" class="button" :disabled="saving || loading" @click="save">
        {{ saving ? 'Salvando…' : 'Salvar roteiro' }}
      </button>
    </div>
  </div>
</template>

<style>
/* O Chatwoot alterna tema pela classe `dark` no html (tailwind darkMode:'class').
   Os blocos precisam de par fundo/texto próprio nos DOIS temas — herdar a cor do
   texto do tema por cima de um fundo fixo branco deixava tudo ilegível. */
.fcanvas {
  position: relative;
  height: 460px;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
  background-color: #f8fafc;
  background-image:
    repeating-linear-gradient(0deg, rgba(100, 116, 139, 0.13) 0 1px, transparent 1px 20px),
    repeating-linear-gradient(90deg, rgba(100, 116, 139, 0.13) 0 1px, transparent 1px 20px);
  border: 1px solid rgba(100, 116, 139, 0.28);
}
.fcanvas:active { cursor: grabbing; }
/* Tela cheia: cobre a janela toda. z-index alto para passar por cima da barra
   lateral do Chatwoot; o Esc e o X vermelho voltam ao normal. */
.fcanvas.is-full {
  position: fixed;
  inset: 0;
  height: 100vh;
  width: 100vw;
  border-radius: 0;
  border: none;
  z-index: 9990;
}

/* ---- barra flutuante do canvas ------------------------------------------ */
.ftoolbar {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(100, 116, 139, 0.22);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(8px);
}
.dark .ftoolbar {
  background: rgba(32, 44, 52, 0.94);
  border-color: rgba(148, 163, 184, 0.22);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
}
/* A barra é uma COLUNA de duas fileiras: blocos em cima, controles embaixo.
   Antes era um flex-wrap único e os controles quebravam misturados. */
.ftoolbar { flex-direction: column; align-items: stretch; gap: 8px; }
.ftrow { display: flex; flex-wrap: wrap; align-items: center; gap: 5px; }
.ftrow.is-ctl {
  gap: 8px; padding-top: 8px;
  border-top: 1px solid rgba(100, 116, 139, 0.18);
}
.dark .ftrow.is-ctl { border-top-color: rgba(148, 163, 184, 0.16); }
/* Cada grupo é uma "ilha" com fundo próprio: separa por função sem precisar
   de barrinhas divisórias. */
.fgrp {
  display: flex; align-items: center; gap: 5px; flex-wrap: wrap;
  padding: 4px 6px; border-radius: 10px;
  background: rgba(100, 116, 139, 0.10);
}
.dark .fgrp { background: rgba(148, 163, 184, 0.10); }
.fgrp.is-tpl { margin-left: auto; }        /* modelos encostam à direita */
.fgrp.is-io { margin-left: auto; }         /* arquivo encosta à direita também */
/* Com os DOIS grupos à direita, só o primeiro empurra — senão o `auto` de cada
   um soma e abre um vão duplo entre eles. Em modo consulta o grupo de modelos
   não é renderizado, o seletor não casa e o "Arquivo" reassume o `auto`. */
.fgrp.is-tpl + .fgrp.is-io { margin-left: 0; }
.fgrp-tag {
  font-size: 10px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase;
  color: #64748b; padding: 0 2px;
}
.dark .fgrp-tag { color: #94a3b8; }
/* Dica do modelo padrão: só o super admin vê, então fica discreta e quebra
   linha antes de empurrar a barra (max-width) em tela estreita. */
.fgrp-dica {
  font-size: 10px; line-height: 1.25; color: #64748b;
  max-width: 210px; padding: 0 2px;
}
.dark .fgrp-dica { color: #94a3b8; }
.ftools-group { display: flex; align-items: center; gap: 5px; flex-wrap: wrap; }
.ftools-sep {
  width: 1px; height: 20px; margin: 0 3px;
  background: rgba(100, 116, 139, 0.28);
}
.dark .ftools-sep { background: rgba(148, 163, 184, 0.26); }

.ftool {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  padding: 5px 9px;
  border-radius: 8px;
  border: 1px solid rgba(100, 116, 139, 0.28);
  /* fundo SÓLIDO: transparente sumia no escuro do canvas */
  background: #f1f5f9;
  color: #334155;
  white-space: nowrap;
  cursor: pointer;
  transition: background .13s, border-color .13s, color .13s, transform .1s;
}
.ftool:hover:not(:disabled) { background: #e2e8f0; transform: translateY(-1px); }
.ftool:disabled { opacity: .45; cursor: default; }
.dark .ftool {
  color: #e2e8f0; border-color: rgba(148, 163, 184, 0.26);
  background: rgba(148, 163, 184, 0.16);
}
.dark .ftool:hover:not(:disabled) { background: rgba(148, 163, 184, 0.28); }
/* Blocos da paleta: leve destaque na borda para lerem como "peças". */
.ftool.is-block { background: #fff; }
.dark .ftool.is-block { background: rgba(255, 255, 255, 0.07); }
.ftool.is-block:hover { border-color: #00a884; color: #00a884; }
.dark .ftool.is-block:hover { color: #4fd1b0; }
/* Cores por função — o olho acha o botão sem ler. */
.ftool.is-view { background: #e0ecff; color: #1d4ed8; border-color: #93b4fd; }
.dark .ftool.is-view { background: rgba(59,130,246,.22); color: #93b4fd; border-color: rgba(59,130,246,.4); }
.ftool.is-save { background: #6d28d9; color: #fff; border-color: #6d28d9; }
.ftool.is-save:hover:not(:disabled) { background: #5b21b6; }
.ftool.is-use { background: #0ea5e9; color: #fff; border-color: #0ea5e9; }
.ftool.is-use:hover:not(:disabled) { background: #0284c7; }
/* Definir como padrão: âmbar, mesma família do grupo "Arquivo" (ação de
   alcance global, não do roteiro que está na tela). */
.ftool.is-padrao { background: #fff7ed; color: #b45309; border-color: #fcd34d; }
.ftool.is-padrao:hover:not(:disabled) { background: #fde68a; color: #78350f; border-color: #f59e0b; }
.dark .ftool.is-padrao { background: rgba(245,158,11,.18); color: #fcd34d; border-color: rgba(245,158,11,.36); }
.dark .ftool.is-padrao:hover:not(:disabled) { background: rgba(245,158,11,.30); color: #fde68a; }
.ftool.is-del { background: #fee2e2; color: #dc2626; border-color: #fca5a5; }
.dark .ftool.is-del { background: rgba(220,38,38,.18); color: #fca5a5; border-color: rgba(220,38,38,.35); }
/* Arquivo (exportar/copiar): âmbar, para não competir com o azul de "Usar"
   nem com o verde do salvar. */
.ftool.is-io-exp { background: #fef3c7; color: #92400e; border-color: #fcd34d; }
.ftool.is-io-exp:hover:not(:disabled) { background: #fde68a; color: #78350f; border-color: #f59e0b; }
.dark .ftool.is-io-exp { background: rgba(245,158,11,.20); color: #fcd34d; border-color: rgba(245,158,11,.38); }
.dark .ftool.is-io-exp:hover:not(:disabled) { background: rgba(245,158,11,.32); color: #fde68a; }
.ftool:hover { border-color: #00a884; color: #00a884; background: rgba(0, 168, 132, 0.08); }
.ftool-ico { font-size: 13px; }
.ftool.is-icon {
  width: 28px; height: 28px; padding: 0;
  justify-content: center; font-size: 16px; font-weight: 700;
}
.ftool.is-test {
  border-color: #00a884; color: #fff; background: #00a884;
}
.ftool.is-test:hover { background: #01916f; color: #fff; }
/* E1: mesma cor do "Salvar configuração" do pai (.fsalvar) — é a MESMA ação,
   só que alcançável de dentro do canvas, inclusive em tela cheia. */
.ftool.is-save-flow {
  border-color: #00a884; color: #fff; background: #00a884; font-weight: 700;
}
.ftool.is-save-flow:hover:not(:disabled) { background: #01916f; color: #fff; }
.fzoom-val {
  font-size: 11.5px; font-weight: 700; min-width: 40px; text-align: center;
  color: #64748b;
}
.dark .fzoom-val { color: #9fb0ba; }

/* ---- modal de importar roteiro ------------------------------------------- */
/* m8 (revisão 2026-08-13): antes valia 9990, EMPATADO com .fcanvas.is-full —
   só funcionava por ordem de DOM. Subido para 9996: acima do canvas em tela
   cheia (9990) e do painel do bloco em tela cheia (.fpanel.is-full, 9995),
   ainda abaixo do .fclose (9999, mas escondido enquanto o modal está aberto —
   ver o v-if dele no template) e do simulador (.fsim-backdrop, 10000), que é
   quem tem que ficar por cima de tudo. */
.fio-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9996;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(8, 12, 16, 0.62);
  backdrop-filter: blur(3px);
}
.fio-modal {
  width: 100%;
  max-width: 560px;
  max-height: 88vh;
  overflow: auto;
  padding: 18px 20px;
  border-radius: 14px;
  background: #fff;
  color: #0f172a;
  border: 1px solid rgba(100, 116, 139, 0.22);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4);
}
.dark .fio-modal {
  background: #1f2933;
  color: #e2e8f0;
  border-color: rgba(148, 163, 184, 0.24);
}
.fio-modal textarea { width: 100%; font-size: 11.5px; }

/* ---- simulador em moldura de iPhone -------------------------------------- */
.fsim-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  background: rgba(8, 12, 16, 0.72);
  backdrop-filter: blur(3px);
}
.fphone {
  position: relative;
  width: 330px;
  height: 668px;
  border-radius: 46px;
  padding: 11px;
  background: linear-gradient(160deg, #3a4148, #16191c 40%, #23282d);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(255, 255, 255, 0.07) inset;
  flex: 0 0 auto;
}
.fphone-notch {
  position: absolute;
  top: 20px; left: 50%; transform: translateX(-50%);
  width: 108px; height: 26px; border-radius: 14px;
  background: #0b0e10; z-index: 3;
}
.fphone-bar {
  position: absolute;
  bottom: 8px; left: 50%; transform: translateX(-50%);
  width: 128px; height: 4px; border-radius: 3px;
  background: rgba(255, 255, 255, 0.55); z-index: 3;
}
.fphone-screen {
  position: relative;
  height: 100%;
  border-radius: 36px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #0b141a;
}
.fphone-top {
  display: flex; align-items: center; gap: 9px;
  padding: 42px 14px 10px;
  background: #1f2c34;
  color: #e9edef;
  flex: 0 0 auto;
}
.fphone-avatar {
  width: 32px; height: 32px; border-radius: 50%;
  background: #00a884; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 14px;
}
.fphone-name { font-size: 13.5px; font-weight: 600; line-height: 1.2; }
.fphone-status { font-size: 11px; color: #8fa3ad; }

.fphone-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: #0b141a;
  background-image: radial-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 18px 18px;
}
.fmsg-row { display: flex; }
.fmsg-row.is-cli { justify-content: flex-end; }
.fmsg-row.is-sys { justify-content: center; }
.fmsg {
  max-width: 78%;
  padding: 6px 9px;
  border-radius: 9px;
  font-size: 12.8px;
  line-height: 1.34;
  color: #e9edef;
  word-break: break-word;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
}
.fmsg.is-in { background: #202c33; border-top-left-radius: 2px; }
.fmsg.is-out { background: #005c4b; border-top-right-radius: 2px; }
.fmsg-sys {
  font-size: 11px;
  color: #cfd8dc;
  background: rgba(255, 255, 255, 0.08);
  padding: 4px 10px;
  border-radius: 8px;
}
.fsim-btns { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.fsim-btns button {
  border: 1px solid #00a884;
  color: #00a884;
  background: transparent;
  border-radius: 16px;
  padding: 6px 13px;
  font-size: 12.5px;
  font-weight: 600;
}
.fsim-btns button:hover { background: #00a884; color: #fff; }

.fphone-composer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 10px 26px;
  background: #1f2c34;
}
.fphone-composer input {
  flex: 1; min-width: 0; height: 34px;
  border-radius: 18px; padding: 0 13px;
  font-size: 12.8px;
  background: #2a3942; color: #e9edef;
  border: none;
}
.fphone-composer input::placeholder { color: #8696a0; }
.fphone-composer input:disabled { opacity: .75; }
.fsend {
  width: 34px; height: 34px; border-radius: 50%; border: none;
  background: #00a884; color: #fff; font-size: 14px; cursor: pointer;
  flex: 0 0 auto;
}
.fsend.is-off { background: #3a4a52; cursor: default; }

.fsim-actions { display: flex; flex-direction: column; gap: 10px; }
.fsim-restart {
  font-size: 12px; font-weight: 600; color: #fff;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 8px; padding: 7px 12px; white-space: nowrap;
}
.fsim-restart:hover { background: rgba(255, 255, 255, 0.24); }
.fsim-close {
  width: 40px; height: 40px; border-radius: 50%; border: none;
  background: #e02c3d; color: #fff; font-size: 18px; font-weight: 700;
  cursor: pointer; box-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
  align-self: center;
}
.fsim-close:hover { background: #c31f2f; }

.fclose {
  /* canto DIREITO: no centro ele caía em cima da paleta de blocos */
  position: fixed;
  top: 14px;
  right: 16px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #e02c3d;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.35);
}
.fclose:hover { background: #c31f2f; }

/* Painel do bloco selecionado vira flutuante em tela cheia, senão ficaria
   escondido embaixo do canvas. */
/* O painel virou <fieldset> (para o modo consulta desabilitar tudo de uma vez):
   zera a borda/margem/padding que o browser dá de graça ao fieldset e o
   min-width:auto que quebra o flex/overflow dos filhos. O p-4/rounded do
   Tailwind continuam valendo. */
.fpanel {
  background: rgba(148, 163, 184, 0.07);
  border: 0;
  margin: 0;
  min-width: 0;
}
/* Consulta: campos travados ficam visivelmente inertes, sem virar ilegíveis. */
.fpanel:disabled { opacity: 0.72; }
.fpanel:disabled input,
.fpanel:disabled select,
.fpanel:disabled textarea,
.fpanel:disabled button { cursor: not-allowed; }
.fpanel.is-full {
  position: fixed;
  top: 70px;
  right: 18px;
  z-index: 9995;
  width: 330px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid rgba(100, 116, 139, 0.3);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.22);
}
.dark .fpanel.is-full {
  background: #1f2c34;
  border-color: rgba(148, 163, 184, 0.3);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.55);
}
.dark .fcanvas {
  background-color: #111b21;
  background-image:
    repeating-linear-gradient(0deg, rgba(148, 163, 184, 0.14) 0 1px, transparent 1px 20px),
    repeating-linear-gradient(90deg, rgba(148, 163, 184, 0.14) 0 1px, transparent 1px 20px);
  border-color: rgba(148, 163, 184, 0.22);
}

.fedge { stroke: rgba(71, 85, 105, 0.55); pointer-events: none; transition: stroke .12s; }
.dark .fedge { stroke: rgba(148, 163, 184, 0.6); }
/* Trilho invisível só para capturar o mouse — a curva de 2px é fina demais. */
.fedge-hit { stroke: transparent; pointer-events: stroke; cursor: pointer; }
.fedge-g:hover .fedge { stroke: #e02c3d; stroke-width: 2.5; }
/* Lixeira no meio da curva: só aparece com o mouse em cima da ligação. */
.fedge-del { opacity: 0; pointer-events: none; cursor: pointer; transition: opacity .12s; }
.fedge-g:hover .fedge-del { opacity: 1; pointer-events: all; }
.fedge-del circle { fill: #e02c3d; }
.fedge-del path { stroke: #fff; stroke-width: 2; stroke-linecap: round; }
.fedge-del:hover circle { fill: #c31f2f; }

.fcard {
  border-radius: 10px;
  padding: 9px 10px;
  cursor: move;
  background: #ffffff;
  color: #0f172a;
  border: 2px solid rgba(100, 116, 139, 0.35);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.10);
  transition: border-color .15s, box-shadow .15s;
}
.fcard.is-selected {
  border-color: #00a884;
  box-shadow: 0 0 0 3px rgba(0, 168, 132, 0.18), 0 2px 8px rgba(15, 23, 42, 0.14);
}
.dark .fcard {
  background: #1f2c34;
  color: #e9edef;
  border-color: rgba(148, 163, 184, 0.30);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
}

.fcard-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .01em;
}
.fcard-start { color: #00a884; font-size: 11px; font-weight: 700; }

.fcard-text {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.3;
  word-break: break-word;
  color: #475569;
}
.dark .fcard-text { color: #aebac1; }

.fcard-meta { margin-top: 5px; font-size: 11.5px; font-weight: 600; color: #0f7c63; }
.dark .fcard-meta { color: #4fd1b0; }

.fcard-chips { margin-top: 6px; display: flex; flex-wrap: wrap; gap: 4px; }
.fchip {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 9px;
  background: rgba(0, 168, 132, 0.14);
  color: #0f7c63;
  border: 1px solid rgba(0, 168, 132, 0.30);
}
.dark .fchip {
  background: rgba(0, 168, 132, 0.20);
  color: #6ee7c4;
  border-color: rgba(0, 168, 132, 0.42);
}

/* Bolinha de saída: cheia = ligada, vazada = solta (é o aviso visual de que
   falta ligar aquele caminho). */
.fport {
  /* E3: `top` vem inline (:style, ligado a nodeHeight(n)) — a altura do
     card cresce com o conteúdo (chips de opção em flex-wrap), então um
     valor fixo aqui deixava a porta/curva presa no offset antigo, por
     cima do meio dos chips quando o card crescia. */
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  cursor: crosshair;
  background: #ffffff;
  border: 2px solid #94a3b8;
  transition: transform .12s;
}
.fport:hover { transform: scale(1.25); }
.fport.is-linked { background: #00a884; border-color: #00a884; }
.dark .fport { background: #1f2c34; border-color: #94a3b8; }
.dark .fport.is-linked { background: #00a884; border-color: #4fd1b0; }

/* seletor de modelos na barra */
.ftool-sel {
  height: 28px; max-width: 150px; font-size: 12px; padding: 0 6px;
  border-radius: 7px; border: 1px solid rgba(148,163,184,.35);
  background: #fff; color: inherit;
}
.dark .ftool-sel { background: #1f2c34; border-color: rgba(148,163,184,.25); }
.ftool:disabled { opacity: .45; cursor: default; }

.fsplash-prev img{max-width:100%;max-height:120px;border-radius:8px;display:block}
/* nós de ação (HTTP / Supabase / Script) */
.fhelp { font-size: 11px; color: #64748b; margin-bottom: 8px; line-height: 1.4; }
.fhelp code { background: rgba(148,163,184,.18); padding: 0 4px; border-radius: 4px; }
.fx {
  width: 26px; flex: 0 0 26px; border-radius: 6px; border: 1px solid #e2426022;
  background: rgba(241,92,109,.12); color: #f15c6d; font-size: 12px;
}
.fadd {
  font-size: 12px; color: #00a884; background: rgba(0,168,132,.10);
  border: 1px dashed #00a88455; border-radius: 6px; padding: 4px 10px; display: inline-block;
}
.ftest {
  width: 100%; padding: 8px; border-radius: 8px; font-weight: 600; color: #fff;
  background: #0ea5e9; margin-top: 4px;
}
.ftest:disabled { opacity: .6; }
.fresult {
  margin-top: 8px; padding: 8px; border-radius: 8px; font-size: 11px;
  background: #0b141a; color: #93e6c8; max-height: 200px; overflow: auto;
  white-space: pre-wrap; word-break: break-word;
}
/* bancos do nó "Consultar oferta" */
.fbancos { display: flex; flex-wrap: wrap; gap: 6px; }
.fbanco {
  display: flex; align-items: center; gap: 6px; cursor: pointer; font-size: 12px;
  padding: 4px 10px; border-radius: 999px; background: rgba(148,163,184,.10);
  border: 1px solid rgba(148,163,184,.28);
}
.fbanco input { margin: 0; width: auto; }
/* prioridade dos bancos marcados (D) */
.fprioridade { display: flex; flex-direction: column; gap: 4px; padding: 0; margin: 0; list-style: none; }
.fprioridade-item {
  display: flex; align-items: center; gap: 8px; font-size: 12px;
  padding: 4px 8px; border-radius: 6px; background: rgba(148,163,184,.08);
  border: 1px solid rgba(148,163,184,.20);
}
.fprioridade-num { font-weight: 600; color: #64748b; width: 20px; flex: 0 0 20px; }
.fprioridade-btn {
  width: 22px; height: 22px; flex: 0 0 22px; border-radius: 5px; font-size: 11px;
  border: 1px solid rgba(148,163,184,.28); background: rgba(148,163,184,.10);
}
.fprioridade-btn:disabled { opacity: .35; cursor: default; }
</style>
